import clsx from "clsx";
import { ProgressIconProps } from "./types";

export const Icons = {
  AnouncementIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={12} height={12} viewBox="0 0 12 12" fill="none">
      <path
        d="M11 3.99996V5.99996M5.125 2.74996H3.4C2.55992 2.74996 2.13988 2.74996 1.81901 2.91345C1.53677 3.05726 1.3073 3.28673 1.16349 3.56897C0.999999 3.88984 0.999999 4.30988 1 5.14996L1 5.74996C1 6.2159 1 6.44887 1.07612 6.63264C1.17762 6.87767 1.37229 7.07234 1.61732 7.17384C1.80109 7.24996 2.03406 7.24996 2.5 7.24996V9.37496C2.5 9.49104 2.5 9.54908 2.50482 9.59797C2.55158 10.0728 2.92721 10.4484 3.40198 10.4951C3.45087 10.5 3.50892 10.5 3.625 10.5C3.74109 10.5 3.79913 10.5 3.84802 10.4951C4.3228 10.4484 4.69842 10.0728 4.74519 9.59797C4.75 9.54908 4.75 9.49104 4.75 9.37496V7.24996H5.125C6.00821 7.24996 7.08862 7.7234 7.92215 8.17778C8.40841 8.44286 8.65155 8.57539 8.81079 8.55589C8.95845 8.53781 9.0701 8.47151 9.15666 8.35051C9.25 8.22003 9.25 7.95896 9.25 7.43681V2.5631C9.25 2.04095 9.25 1.77988 9.15666 1.6494C9.0701 1.52841 8.95845 1.46211 8.81079 1.44402C8.65155 1.42452 8.40841 1.55706 7.92215 1.82213C7.08862 2.27651 6.00821 2.74996 5.125 2.74996Z"
        stroke="#A1A1AA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  StatsIcon: (props: React.SVGProps<SVGSVGElement>) => {
    const { mode } = props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        className="-mt-1"
        {...props}
      >
        <path
          d="M2 7.33333L2 14M10 7.33333L10 14M6 2L6 14M14 2V14"
          stroke={mode === "dark" ? "white" : "black"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  InputIcon: (props: React.SVGProps<SVGSVGElement>) => {
    const { mode, stroke, ...rest } = props;
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 24 24" fill="none" {...rest}>
        <path
          d="M4 6H20C21.1046 6 22 6.89543 22 8V16C22 17.1046 21.1046 18 20 18H4C2.89543 18 2 17.1046 2 16V8C2 6.89543 2.89543 6 4 6Z"
          stroke={stroke ? stroke : mode === "light" ? "#52525B" : "#A1A1AA"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 8.5H6.5M8 8.5H6.5M6.5 8.5V15.5M6.5 15.5H5M6.5 15.5H8"
          stroke={stroke ? stroke : mode === "light" ? "#52525B" : "#A1A1AA"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },

  WarningIcon: (props: React.SVGProps<SVGSVGElement>) => {
    const { stroke = "rgb(255,170,0)", ...rest } = props;
    return (
      <svg width={20} height={20} viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <path
          d="M85.57,446.25H426.43a32,32,0,0,0,28.17-47.17L284.18,82.58c-12.09-22.44-44.27-22.44-56.36,0L57.4,399.08A32,32,0,0,0,85.57,446.25Z"
          fill="none"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="32px"
        />
        <path
          d="M250.26,195.39l5.74,122,5.73-121.95a5.74,5.74,0,0,0-5.79-6h0A5.74,5.74,0,0,0,250.26,195.39Z"
          fill="none"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="32px"
        />
        <path fill={stroke} d="M256,397.25a20,20,0,1,1,20-20A20,20,0,0,1,256,397.25Z" />
      </svg>
    );
  },
  RangeIcon: (props: React.SVGProps<SVGSVGElement>) => {
    const { mode, stroke, ...rest } = props;
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 24 24" fill="none" {...rest}>
        <path
          d="M6.75469 17.2828L5.32612 7.28284C5.154 6.07798 6.08892 5 7.30602 5H10.694C11.9111 5 12.846 6.07797 12.6739 7.28284L11.2453 17.2828C11.1046 18.2681 10.2607 19 9.26541 19H8.73459C7.73929 19 6.89545 18.2681 6.75469 17.2828Z"
          stroke={stroke ? stroke : mode === "light" ? "#52525B" : "#A1A1AA"}
          strokeWidth="1.5"
        />
        <path
          d="M2 12L6 12M22 12L12 12"
          stroke={stroke ? stroke : mode === "light" ? "#52525B" : "#A1A1AA"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  SpinIcon: (props: React.SVGProps<SVGSVGElement>) => {
    const { className, ...rest } = props;
    return (
      <svg
        viewBox="0 0 24 24"
        className={clsx("animate-spin", className)}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <path
          d="M12 2V6M12 18V22M6 12H2M22 12H18M19.0784 19.0784L16.25 16.25M19.0784 4.99994L16.25 7.82837M4.92157 19.0784L7.75 16.25M4.92157 4.99994L7.75 7.82837"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },

  LinkIcon: (props: React.SVGProps<SVGSVGElement>) => {
    const { mode, stroke } = props;
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width={17} height={16} {...props} viewBox="0 0 17 16" fill="none">
        <g clipPath="url(#clip0_3722_166195)">
          <path
            d="M7.1668 8.66665C7.4531 9.0494 7.81837 9.3661 8.23783 9.59528C8.6573 9.82445 9.12114 9.96073 9.5979 9.99487C10.0747 10.029 10.5532 9.96023 11.001 9.79317C11.4489 9.62611 11.8555 9.3647 12.1935 9.02665L14.1935 7.02665C14.8007 6.39798 15.1366 5.55597 15.129 4.68198C15.1215 3.80799 14.7709 2.97195 14.1529 2.35392C13.5348 1.73589 12.6988 1.38533 11.8248 1.37774C10.9508 1.37014 10.1088 1.70612 9.48013 2.31332L8.33347 3.45332M9.83347 7.33332C9.54716 6.95056 9.18189 6.63386 8.76243 6.40469C8.34297 6.17552 7.87913 6.03924 7.40237 6.00509C6.9256 5.97095 6.44708 6.03974 5.99924 6.20679C5.5514 6.37385 5.14472 6.63527 4.8068 6.97332L2.8068 8.97332C2.19961 9.60199 1.86363 10.444 1.87122 11.318C1.87881 12.192 2.22938 13.028 2.8474 13.646C3.46543 14.2641 4.30147 14.6146 5.17546 14.6222C6.04945 14.6298 6.89146 14.2938 7.52013 13.6866L8.66013 12.5466"
            stroke={stroke ? stroke : mode === "light" ? "#52525B" : "#A1A1AA"}
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_3722_166195">
            <rect width={16} height={16} fill="white" transform="translate(0.5)" />
          </clipPath>
        </defs>
      </svg>
    );
  },

  LinkNetworkIcon: (props: React.SVGProps<SVGSVGElement>) => {
    const { mode, stroke } = props;
    return (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.47203 12.2423L7.52922 13.1851C6.22748 14.4868 4.11693 14.4868 2.81518 13.1851C1.51343 11.8834 1.51343 9.7728 2.81518 8.47106L3.75799 7.52825M12.2433 8.47106L13.1861 7.52825C14.4878 6.2265 14.4878 4.11595 13.1861 2.8142C11.8843 1.51245 9.77378 1.51245 8.47203 2.8142L7.52922 3.75701M5.66729 10.333L10.334 5.6663"
          stroke={stroke ? stroke : mode === "light" ? "#52525B" : "#A1A1AA"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },

  LinkBrokenIcon: (props: React.SVGProps<SVGSVGElement>) => {
    const { mode, stroke } = props;
    return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9 4V2M15 20V22M4 9H2M20 15H22M4.91421 4.91421L3.5 3.5M19.0858 19.0858L20.5 20.5M12 17.6569L9.87868 19.7782C8.31658 21.3403 5.78392 21.3403 4.22183 19.7782C2.65973 18.2161 2.65973 15.6834 4.22183 14.1213L6.34315 12M17.6569 12L19.7782 9.87868C21.3403 8.31658 21.3403 5.78392 19.7782 4.22183C18.2161 2.65973 15.6834 2.65973 14.1213 4.22183L12 6.34315"
          stroke={stroke ? stroke : mode === "light" ? "#52525B" : "#A1A1AA"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },

  InstagramIcon: (props: React.SVGProps<SVGSVGElement>) => {
    return (
      <svg {...props} xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none">
        <path
          d="M10.0009 1.66666C7.73764 1.66666 7.45361 1.67656 6.56472 1.71701C5.67755 1.75764 5.07199 1.89809 4.54212 2.10416C3.99403 2.31701 3.52909 2.60173 3.06589 3.0651C2.60235 3.5283 2.31762 3.99323 2.10408 4.54114C1.89748 5.07118 1.75685 5.67691 1.71692 6.56371C1.67716 7.4526 1.66675 7.7368 1.66675 10C1.66675 12.2632 1.67682 12.5464 1.7171 13.4352C1.75789 14.3224 1.89835 14.9279 2.10425 15.4578C2.31728 16.0059 2.602 16.4708 3.06537 16.934C3.5284 17.3976 3.99333 17.683 4.54108 17.8958C5.0713 18.1019 5.67703 18.2424 6.56402 18.283C7.45292 18.3234 7.73678 18.3333 9.99982 18.3333C12.2632 18.3333 12.5464 18.3234 13.4353 18.283C14.3224 18.2424 14.9287 18.1019 15.4589 17.8958C16.0068 17.683 16.4711 17.3976 16.9341 16.934C17.3976 16.4708 17.6824 16.0059 17.8959 15.458C18.1008 14.9279 18.2414 14.3222 18.2831 13.4354C18.323 12.5465 18.3334 12.2632 18.3334 10C18.3334 7.7368 18.323 7.45278 18.2831 6.56389C18.2414 5.67673 18.1008 5.07118 17.8959 4.54132C17.6824 3.99323 17.3976 3.5283 16.9341 3.0651C16.4705 2.60156 16.007 2.31684 15.4584 2.10416C14.9271 1.89809 14.3212 1.75764 13.4341 1.71701C12.5452 1.67656 12.2622 1.66666 9.99826 1.66666H10.0009ZM9.25329 3.1684C9.47516 3.16805 9.72273 3.1684 10.0009 3.1684C12.2259 3.1684 12.4896 3.17639 13.3683 3.21632C14.1808 3.25347 14.6217 3.38923 14.9155 3.5033C15.3044 3.65434 15.5816 3.83489 15.8731 4.12656C16.1648 4.41823 16.3454 4.696 16.4968 5.08489C16.6108 5.3783 16.7468 5.81927 16.7837 6.63177C16.8237 7.51024 16.8324 7.77413 16.8324 9.99809C16.8324 12.222 16.8237 12.4859 16.7837 13.3644C16.7466 14.1769 16.6108 14.6179 16.4968 14.9113C16.3457 15.3002 16.1648 15.5771 15.8731 15.8686C15.5815 16.1602 15.3046 16.3408 14.9155 16.4918C14.6221 16.6064 14.1808 16.7418 13.3683 16.779C12.4898 16.8189 12.2259 16.8276 10.0009 16.8276C7.77566 16.8276 7.51195 16.8189 6.63347 16.779C5.82096 16.7415 5.37998 16.6057 5.08605 16.4917C4.69716 16.3406 4.41938 16.1601 4.12771 15.8684C3.83604 15.5767 3.65548 15.2997 3.50409 14.9106C3.39003 14.6172 3.25409 14.1762 3.21711 13.3637C3.17718 12.4852 3.16919 12.2214 3.16919 9.996C3.16919 7.77066 3.17718 7.50816 3.21711 6.62968C3.25426 5.81718 3.39003 5.37621 3.50409 5.08246C3.65514 4.69357 3.83604 4.4158 4.12771 4.12413C4.41938 3.83246 4.69716 3.65191 5.08605 3.50052C5.37981 3.38593 5.82096 3.25052 6.63347 3.21319C7.40222 3.17847 7.70014 3.16805 9.25329 3.16632V3.1684ZM14.4492 4.55208C13.8971 4.55208 13.4492 4.99948 13.4492 5.55173C13.4492 6.10382 13.8971 6.55173 14.4492 6.55173C15.0013 6.55173 15.4492 6.10382 15.4492 5.55173C15.4492 4.99965 15.0013 4.55173 14.4492 4.55173V4.55208ZM10.0009 5.72048C7.63747 5.72048 5.7213 7.63663 5.7213 10C5.7213 12.3634 7.63747 14.2786 10.0009 14.2786C12.3643 14.2786 14.2797 12.3634 14.2797 10C14.2797 7.63663 12.3643 5.72048 10.0009 5.72048ZM10.0009 7.22222C11.5349 7.22222 12.7787 8.4658 12.7787 10C12.7787 11.534 11.5349 12.7778 10.0009 12.7778C8.46664 12.7778 7.22306 11.534 7.22306 10C7.22306 8.4658 8.46664 7.22222 10.0009 7.22222Z"
          fill="white"
        />
      </svg>
    );
  },
  FacebookIcon: (props: React.SVGProps<SVGSVGElement>) => {
    return (
      <svg {...props} xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none">
        <path
          d="M10.8308 17.5V10.6581H13.1022L13.4413 7.99132H10.8308V6.29113C10.8308 5.51645 11.041 4.99543 12.1394 4.99543H13.5362V2.60283C13.2921 2.56856 12.4649 2.5 11.502 2.5C9.48821 2.5 8.11176 3.74086 8.11176 6.02377V7.99132H5.8335V10.6581H8.11176V17.5H10.8308Z"
          fill="white"
        />
      </svg>
    );
  },
  TwitterIcon: (props: React.SVGProps<SVGSVGElement>) => {
    return (
      <svg {...props} xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none">
        <path
          d="M18.6665 4.62467C18.0285 4.908 17.3432 5.09867 16.6239 5.18467C17.3585 4.74467 17.9219 4.048 18.1872 3.21734C17.5005 3.62467 16.7392 3.92067 15.9285 4.08067C15.2799 3.38934 14.3559 2.95734 13.3332 2.95734C11.3692 2.95734 9.77719 4.55 9.77719 6.51334C9.77719 6.792 9.80919 7.064 9.86919 7.32334C6.91385 7.17534 4.29385 5.75934 2.53919 3.60734C2.23385 4.13267 2.05852 4.74334 2.05852 5.396C2.05852 6.62934 2.68585 7.718 3.63985 8.35534C3.05719 8.33667 2.50852 8.17667 2.02919 7.91067C2.02919 7.926 2.02919 7.94 2.02919 7.95534C2.02919 9.67867 3.25452 11.116 4.88185 11.442C4.58385 11.5233 4.26919 11.5667 3.94452 11.5667C3.71585 11.5667 3.49252 11.544 3.27585 11.5033C3.72852 12.916 5.04185 13.9447 6.59785 13.9733C5.38119 14.9273 3.84785 15.496 2.18119 15.496C1.89452 15.496 1.61119 15.4793 1.33252 15.446C2.90652 16.4547 4.77519 17.0433 6.78385 17.0433C13.3252 17.0433 16.9012 11.6247 16.9012 6.92534C16.9012 6.77134 16.8979 6.618 16.8912 6.46534C17.5865 5.96334 18.1899 5.33734 18.6665 4.62467Z"
          fill="white"
        />
      </svg>
    );
  },

  YoutubeIcon: (props: React.SVGProps<SVGSVGElement>) => {
    return (
      <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_165_696)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.8252 3.42831C18.6819 3.65902 19.3574 4.33438 19.5879 5.19115C20.0164 6.75609 19.9999 10.0181 19.9999 10.0181C19.9999 10.0181 19.9999 13.2635 19.5881 14.8286C19.3574 15.6852 18.682 16.3607 17.8252 16.5913C16.2602 17.0032 9.99996 17.0032 9.99996 17.0032C9.99996 17.0032 3.75609 17.0032 2.17467 16.5749C1.3179 16.3442 0.642545 15.6687 0.411833 14.8121C0 13.2635 0 10.0016 0 10.0016C0 10.0016 0 6.75609 0.411833 5.19115C0.642392 4.33453 1.33438 3.64254 2.17452 3.41199C3.73961 3 9.99981 3 9.99981 3C9.99981 3 16.2602 3 17.8252 3.42831ZM13.2122 10.0017L8.00637 13V7.00335L13.2122 10.0017Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_165_696">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  },

  TelegramIcon: (props: React.SVGProps<SVGSVGElement>) => {
    return (
      <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.45544 12.5451L7.14115 17.0122C7.59082 17.0122 7.78558 16.817 8.01912 16.5827L10.1274 14.5467L14.4959 17.7794C15.2971 18.2306 15.8616 17.993 16.0777 17.0346L18.9452 3.45712L18.946 3.45632C19.2001 2.25952 18.5177 1.79153 17.7371 2.08512L0.882079 8.60589C-0.268241 9.05709 -0.250824 9.70508 0.686532 9.99868L4.99568 11.3531L15.005 5.02431C15.476 4.70911 15.9043 4.88351 15.552 5.19871L7.45544 12.5451Z"
          fill="white"
        />
      </svg>
    );
  },

  ApproveIcon: (props: React.SVGProps<SVGSVGElement>) => {
    const { mode, stroke, fill } = props;
    return (
      <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="22" height="22" rx="11" fill={fill ? fill : "#A855F7"} />
        <rect
          x="1"
          y="1"
          width="22"
          height="22"
          rx="11"
          stroke={mode === "light" ? "#D4D4D8" : "#3F3F46"}
          strokeWidth="2"
        />
        <path
          d="M16 9L10.5 14.5L8 12"
          stroke={stroke ? stroke : "white"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },

  ReferrerIcon: (props: React.SVGProps<SVGSVGElement>) => {
    const { mode, stroke, fill } = props;
    return (
      <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="22" height="22" rx="11" fill={fill ? fill : "#A855F7"} />
        <rect
          x="1"
          y="1"
          width="22"
          height="22"
          rx="11"
          stroke={mode === "light" ? "#D4D4D8" : "#3F3F46"}
          strokeWidth="2"
        />
        <path
          d="M14.5 16H14.4C13.5599 16 13.1399 16 12.819 15.8365C12.5368 15.6927 12.3073 15.4632 12.1635 15.181C12 14.8601 12 14.4401 12 13.6V10.4C12 9.55992 12 9.13988 12.1635 8.81901C12.3073 8.53677 12.5368 8.3073 12.819 8.16349C13.1399 8 13.5599 8 14.4 8H14.5M14.5 16C14.5 16.5523 14.9477 17 15.5 17C16.0523 17 16.5 16.5523 16.5 16C16.5 15.4477 16.0523 15 15.5 15C14.9477 15 14.5 15.4477 14.5 16ZM14.5 8C14.5 8.55228 14.9477 9 15.5 9C16.0523 9 16.5 8.55228 16.5 8C16.5 7.44772 16.0523 7 15.5 7C14.9477 7 14.5 7.44772 14.5 8ZM9.5 12L14.5 12M9.5 12C9.5 12.5523 9.05228 13 8.5 13C7.94772 13 7.5 12.5523 7.5 12C7.5 11.4477 7.94772 11 8.5 11C9.05228 11 9.5 11.4477 9.5 12ZM14.5 12C14.5 12.5523 14.9477 13 15.5 13C16.0523 13 16.5 12.5523 16.5 12C16.5 11.4477 16.0523 11 15.5 11C14.9477 11 14.5 11.4477 14.5 12Z"
          stroke={stroke ? stroke : "white"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },

  InviteIcon: (props: React.SVGProps<SVGSVGElement>) => {
    const { mode } = props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        className="-mt-0.5"
      >
        <path
          d="M13.8609 8.40513C14.0237 8.26563 14.105 8.19589 14.1348 8.11289C14.161 8.04004 14.161 7.96035 14.1348 7.8875C14.105 7.8045 14.0237 7.73476 13.8609 7.59526L8.21375 2.75484C7.9336 2.51471 7.79353 2.39465 7.67493 2.3917C7.57186 2.38915 7.47341 2.43443 7.40828 2.51435C7.33333 2.6063 7.33333 2.7908 7.33333 3.15978V6.02328C5.91021 6.27225 4.60773 6.99337 3.63981 8.07611C2.58455 9.25654 2.00082 10.7842 2 12.3675V12.7755C2.69956 11.9328 3.573 11.2512 4.56051 10.7775C5.43113 10.3598 6.37228 10.1124 7.33333 10.0472V12.8406C7.33333 13.2096 7.33333 13.3941 7.40828 13.486C7.47341 13.566 7.57186 13.6112 7.67493 13.6087C7.79353 13.6057 7.9336 13.4857 8.21375 13.2455L13.8609 8.40513Z"
          stroke={mode === "dark" ? "white" : "black"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  RewardIcon: (props: React.SVGProps<SVGSVGElement>) => {
    const { mode } = props;
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 24 24" fill="none">
        <path
          d="M12 15C8.68629 15 6 12.3137 6 9V3.44444C6 3.0306 6 2.82367 6.06031 2.65798C6.16141 2.38021 6.38021 2.16141 6.65798 2.06031C6.82367 2 7.0306 2 7.44444 2H16.5556C16.9694 2 17.1763 2 17.342 2.06031C17.6198 2.16141 17.8386 2.38021 17.9397 2.65798C18 2.82367 18 3.0306 18 3.44444V9C18 12.3137 15.3137 15 12 15ZM12 15V18M18 4H20.5C20.9659 4 21.1989 4 21.3827 4.07612C21.6277 4.17761 21.8224 4.37229 21.9239 4.61732C22 4.80109 22 5.03406 22 5.5V6C22 6.92997 22 7.39496 21.8978 7.77646C21.6204 8.81173 20.8117 9.62038 19.7765 9.89778C19.395 10 18.93 10 18 10M6 4H3.5C3.03406 4 2.80109 4 2.61732 4.07612C2.37229 4.17761 2.17761 4.37229 2.07612 4.61732C2 4.80109 2 5.03406 2 5.5V6C2 6.92997 2 7.39496 2.10222 7.77646C2.37962 8.81173 3.18827 9.62038 4.22354 9.89778C4.60504 10 5.07003 10 6 10M7.44444 22H16.5556C16.801 22 17 21.801 17 21.5556C17 19.5919 15.4081 18 13.4444 18H10.5556C8.59188 18 7 19.5919 7 21.5556C7 21.801 7.19898 22 7.44444 22Z"
          stroke={mode === "dark" ? "white" : "black"}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },

  DiamondIcon: (props: React.SVGProps<SVGSVGElement>) => {
    const { color = "white" } = props;
    return (
      <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width={12}
        height={12}
        viewBox="0 0 12 12"
        {...props}
        fill="none"
      >
        <path
          d="M1.24977 4.5H10.7498M4.99977 1.5L3.99977 4.5L5.99977 10.25L7.99977 4.5L6.99977 1.5M6.30706 10.1313L10.7864 4.75607C10.8623 4.66498 10.9002 4.61943 10.9148 4.56858C10.9275 4.52375 10.9275 4.47624 10.9148 4.43142C10.9002 4.38057 10.8623 4.33502 10.7864 4.24393L8.61971 1.64393C8.57562 1.59102 8.55358 1.56457 8.52655 1.54555C8.50261 1.5287 8.4759 1.51619 8.44763 1.50858C8.41572 1.5 8.38128 1.5 8.31242 1.5H3.68712C3.61825 1.5 3.58382 1.5 3.55191 1.50858C3.52364 1.51619 3.49692 1.5287 3.47298 1.54555C3.44596 1.56457 3.42392 1.59102 3.37983 1.64393L1.21316 4.24393C1.13725 4.33502 1.09929 4.38057 1.08479 4.43142C1.072 4.47624 1.072 4.52375 1.08479 4.56858C1.09929 4.61943 1.13725 4.66498 1.21316 4.75607L5.69248 10.1313C5.79801 10.2579 5.85077 10.3212 5.91394 10.3443C5.96937 10.3646 6.03017 10.3646 6.08559 10.3443C6.14876 10.3212 6.20153 10.2579 6.30706 10.1313Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  Upload: (props: React.SVGProps<SVGSVGElement>) => {
    const { mode } = props;
    return (
      <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.3337 10.0003L10.0003 6.66699M10.0003 6.66699L6.66699 10.0003M10.0003 6.66699V14.3337C10.0003 15.4926 10.0003 16.072 10.4591 16.7208C10.7639 17.1519 11.6415 17.6839 12.1647 17.7548C12.9521 17.8615 13.2511 17.7055 13.8491 17.3935C16.5142 16.0033 18.3337 13.2143 18.3337 10.0003C18.3337 5.39795 14.6027 1.66699 10.0003 1.66699C5.39795 1.66699 1.66699 5.39795 1.66699 10.0003C1.66699 13.0848 3.34282 15.7779 5.83366 17.2188"
          stroke={mode === "light" ? "black" : "white"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3337 10.0003L10.0003 6.66699M10.0003 6.66699L6.66699 10.0003M10.0003 6.66699V14.3337C10.0003 15.4926 10.0003 16.072 10.4591 16.7208C10.7639 17.1519 11.6415 17.6839 12.1647 17.7548C12.9521 17.8615 13.2511 17.7055 13.8491 17.3935C16.5142 16.0033 18.3337 13.2143 18.3337 10.0003C18.3337 5.39795 14.6027 1.66699 10.0003 1.66699C5.39795 1.66699 1.66699 5.39795 1.66699 10.0003C1.66699 13.0848 3.34282 15.7779 5.83366 17.2188"
          stroke={mode === "light" ? "black" : "white"}
          strokeOpacity="0.2"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3337 10.0003L10.0003 6.66699M10.0003 6.66699L6.66699 10.0003M10.0003 6.66699V14.3337C10.0003 15.4926 10.0003 16.072 10.4591 16.7208C10.7639 17.1519 11.6415 17.6839 12.1647 17.7548C12.9521 17.8615 13.2511 17.7055 13.8491 17.3935C16.5142 16.0033 18.3337 13.2143 18.3337 10.0003C18.3337 5.39795 14.6027 1.66699 10.0003 1.66699C5.39795 1.66699 1.66699 5.39795 1.66699 10.0003C1.66699 13.0848 3.34282 15.7779 5.83366 17.2188"
          stroke={mode === "light" ? "black" : "white"}
          strokeOpacity="0.2"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  SaveIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="none">
      <path
        d="M4.66667 2V4.26667C4.66667 4.64004 4.66667 4.82672 4.73933 4.96933C4.80324 5.09477 4.90523 5.19676 5.03067 5.26067C5.17328 5.33333 5.35997 5.33333 5.73333 5.33333H10.2667C10.64 5.33333 10.8267 5.33333 10.9693 5.26067C11.0948 5.19676 11.1968 5.09477 11.2607 4.96933C11.3333 4.82672 11.3333 4.64004 11.3333 4.26667V2.66667M11.3333 14V9.73333C11.3333 9.35997 11.3333 9.17328 11.2607 9.03067C11.1968 8.90523 11.0948 8.80324 10.9693 8.73933C10.8267 8.66667 10.64 8.66667 10.2667 8.66667H5.73333C5.35997 8.66667 5.17328 8.66667 5.03067 8.73933C4.90523 8.80324 4.80324 8.90523 4.73933 9.03067C4.66667 9.17328 4.66667 9.35997 4.66667 9.73333V14M14 6.21699V10.8C14 11.9201 14 12.4802 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.4802 14 11.9201 14 10.8 14H5.2C4.0799 14 3.51984 14 3.09202 13.782C2.71569 13.5903 2.40973 13.2843 2.21799 12.908C2 12.4802 2 11.9201 2 10.8V5.2C2 4.0799 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.0799 2 5.2 2H9.78301C10.1091 2 10.2722 2 10.4256 2.03684C10.5617 2.0695 10.6918 2.12337 10.811 2.19648C10.9456 2.27894 11.0609 2.39424 11.2915 2.62484L13.3752 4.7085C13.6058 4.9391 13.7211 5.0544 13.8035 5.18895C13.8766 5.30825 13.9305 5.43831 13.9632 5.57436C14 5.72781 14 5.89087 14 6.21699Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  EditIcon: (props: React.SVGProps<SVGSVGElement>) => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" {...props} fill="none">
        <g clipPath="url(#clip0_3188_20723)">
          <path
            d="M7.33334 2.66666H4.53334C3.41324 2.66666 2.85319 2.66666 2.42536 2.88464C2.04904 3.07639 1.74308 3.38235 1.55133 3.75867C1.33334 4.1865 1.33334 4.74655 1.33334 5.86666V11.4667C1.33334 12.5868 1.33334 13.1468 1.55133 13.5746C1.74308 13.951 2.04904 14.2569 2.42536 14.4487C2.85319 14.6667 3.41324 14.6667 4.53334 14.6667H10.1333C11.2534 14.6667 11.8135 14.6667 12.2413 14.4487C12.6176 14.2569 12.9236 13.951 13.1154 13.5746C13.3333 13.1468 13.3333 12.5868 13.3333 11.4667V8.66666M5.33333 10.6667H6.44969C6.77581 10.6667 6.93887 10.6667 7.09232 10.6298C7.22837 10.5972 7.35843 10.5433 7.47772 10.4702C7.61228 10.3877 7.72758 10.2724 7.95818 10.0418L14.3333 3.66666C14.8856 3.11437 14.8856 2.21894 14.3333 1.66666C13.7811 1.11437 12.8856 1.11437 12.3333 1.66665L5.95817 8.04182C5.72756 8.27242 5.61226 8.38772 5.52981 8.52228C5.4567 8.64157 5.40283 8.77163 5.37017 8.90768C5.33333 9.06113 5.33333 9.22419 5.33333 9.55031V10.6667Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.33334 2.66666H4.53334C3.41324 2.66666 2.85319 2.66666 2.42536 2.88464C2.04904 3.07639 1.74308 3.38235 1.55133 3.75867C1.33334 4.1865 1.33334 4.74655 1.33334 5.86666V11.4667C1.33334 12.5868 1.33334 13.1468 1.55133 13.5746C1.74308 13.951 2.04904 14.2569 2.42536 14.4487C2.85319 14.6667 3.41324 14.6667 4.53334 14.6667H10.1333C11.2534 14.6667 11.8135 14.6667 12.2413 14.4487C12.6176 14.2569 12.9236 13.951 13.1154 13.5746C13.3333 13.1468 13.3333 12.5868 13.3333 11.4667V8.66666M5.33333 10.6667H6.44969C6.77581 10.6667 6.93887 10.6667 7.09232 10.6298C7.22837 10.5972 7.35843 10.5433 7.47772 10.4702C7.61228 10.3877 7.72758 10.2724 7.95818 10.0418L14.3333 3.66666C14.8856 3.11437 14.8856 2.21894 14.3333 1.66666C13.7811 1.11437 12.8856 1.11437 12.3333 1.66665L5.95817 8.04182C5.72756 8.27242 5.61226 8.38772 5.52981 8.52228C5.4567 8.64157 5.40283 8.77163 5.37017 8.90768C5.33333 9.06113 5.33333 9.22419 5.33333 9.55031V10.6667Z"
            stroke="white"
            strokeOpacity="0.2"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.33334 2.66666H4.53334C3.41324 2.66666 2.85319 2.66666 2.42536 2.88464C2.04904 3.07639 1.74308 3.38235 1.55133 3.75867C1.33334 4.1865 1.33334 4.74655 1.33334 5.86666V11.4667C1.33334 12.5868 1.33334 13.1468 1.55133 13.5746C1.74308 13.951 2.04904 14.2569 2.42536 14.4487C2.85319 14.6667 3.41324 14.6667 4.53334 14.6667H10.1333C11.2534 14.6667 11.8135 14.6667 12.2413 14.4487C12.6176 14.2569 12.9236 13.951 13.1154 13.5746C13.3333 13.1468 13.3333 12.5868 13.3333 11.4667V8.66666M5.33333 10.6667H6.44969C6.77581 10.6667 6.93887 10.6667 7.09232 10.6298C7.22837 10.5972 7.35843 10.5433 7.47772 10.4702C7.61228 10.3877 7.72758 10.2724 7.95818 10.0418L14.3333 3.66666C14.8856 3.11437 14.8856 2.21894 14.3333 1.66666C13.7811 1.11437 12.8856 1.11437 12.3333 1.66665L5.95817 8.04182C5.72756 8.27242 5.61226 8.38772 5.52981 8.52228C5.4567 8.64157 5.40283 8.77163 5.37017 8.90768C5.33333 9.06113 5.33333 9.22419 5.33333 9.55031V10.6667Z"
            stroke="white"
            strokeOpacity="0.2"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_3188_20723">
            <rect width={16} height={16} fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  },

  TrashIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none">
      <path
        d="M13.3333 4.99996V4.33329C13.3333 3.39987 13.3333 2.93316 13.1517 2.57664C12.9919 2.26304 12.7369 2.00807 12.4233 1.84828C12.0668 1.66663 11.6001 1.66663 10.6667 1.66663H9.33333C8.39991 1.66663 7.9332 1.66663 7.57668 1.84828C7.26308 2.00807 7.00811 2.26304 6.84832 2.57664C6.66667 2.93316 6.66667 3.39987 6.66667 4.33329V4.99996M8.33333 9.58329V13.75M11.6667 9.58329V13.75M2.5 4.99996H17.5M15.8333 4.99996V14.3333C15.8333 15.7334 15.8333 16.4335 15.5608 16.9683C15.3212 17.4387 14.9387 17.8211 14.4683 18.0608C13.9335 18.3333 13.2335 18.3333 11.8333 18.3333H8.16667C6.76654 18.3333 6.06647 18.3333 5.53169 18.0608C5.06129 17.8211 4.67883 17.4387 4.43915 16.9683C4.16667 16.4335 4.16667 15.7334 4.16667 14.3333V4.99996"
        stroke="#A1A1AA"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  BanIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 459.739 459.739"
      fill="#A1A1AA"
    >
      <path
        d="M229.869,0C102.919,0,0,102.918,0,229.87s102.919,229.869,229.869,229.869c126.952,0,229.87-102.917,229.87-229.869
	S356.821,0,229.869,0z M61.299,229.87c0-37.1,12.196-71.325,32.58-99.198L329.062,365.86
	c-27.868,20.392-62.093,32.581-99.192,32.581C136.919,398.441,61.299,322.82,61.299,229.87z M369.138,324.683L135.048,90.601
	c27.044-18.468,59.684-29.303,94.821-29.303c92.952,0,168.571,75.622,168.571,168.572
	C398.44,265.009,387.607,297.649,369.138,324.683z"
      />
    </svg>
  ),
  UnbanIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.63604 18.364C9.15076 21.8787 14.8492 21.8787 18.364 18.364C21.8787 14.8492 21.8787 9.15076 18.364 5.63604C14.8492 2.12132 9.15076 2.12132 5.63604 5.63604C2.12132 9.15076 2.12132 14.8492 5.63604 18.364ZM7.80749 17.6067C10.5493 19.6623 14.4562 19.4433 16.9497 16.9497C19.4433 14.4562 19.6623 10.5493 17.6067 7.80749L14.8284 10.5858C14.4379 10.9763 13.8047 10.9763 13.4142 10.5858C13.0237 10.1953 13.0237 9.5621 13.4142 9.17157L16.1925 6.39327C13.4507 4.33767 9.54384 4.55666 7.05025 7.05025C4.55666 9.54384 4.33767 13.4507 6.39327 16.1925L9.17157 13.4142C9.5621 13.0237 10.1953 13.0237 10.5858 13.4142C10.9763 13.8047 10.9763 14.4379 10.5858 14.8284L7.80749 17.6067Z"
        fill="#A1A1AA"
      />
    </svg>
  ),
  PersonalDetailsIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 108.81 122.88"
      fill="#A1A1AA"
    >
      <path d="M62.72,69.75H99.84a9,9,0,0,1,9,9V113.9a9,9,0,0,1-9,9H62.72a9,9,0,0,1-9-9V78.72a9,9,0,0,1,9-9ZM84.46,28.19a3.15,3.15,0,0,1,2.29,3v5.29H94.6a6.82,6.82,0,0,1,4.88,2,6.91,6.91,0,0,1,2,4.88V60.21h-6V43.42a1,1,0,0,0-.28-.7,1,1,0,0,0-.71-.28H86.75V60.2H80.44V35H54.21A3.17,3.17,0,0,1,51,31.83V6.29H6.32v95.48H43.76v6.31H16.37V116a1,1,0,0,0,.28.7,1,1,0,0,0,.7.28H43.74v5.93H17.39A7,7,0,0,1,10.47,116v-7.88H5.66a5.66,5.66,0,0,1-4-1.65,5.6,5.6,0,0,1-1.66-4V5.65A5.65,5.65,0,0,1,5.66,0H54.21a3.09,3.09,0,0,1,2.42,1.16l27.83,27ZM20,51.62A2.05,2.05,0,0,0,18,53.76,2,2,0,0,0,20,55.89H57A2.05,2.05,0,0,0,59,53.76,2,2,0,0,0,57,51.62Zm0,15.27A2,2,0,0,0,18.06,69,2,2,0,0,0,20,71.15h23.7V66.89Zm0,15.26a2,2,0,0,0-1.92,2.13A2,2,0,0,0,20,86.41h23.7V82.15Zm0-45.79A2,2,0,0,0,18,38.49,2,2,0,0,0,20,40.62H41.89a2,2,0,0,0,1.91-2.13,2,2,0,0,0-1.91-2.13ZM20,21.1a2,2,0,0,0-1.92,2.13A2,2,0,0,0,20,25.36H32a2,2,0,0,0,1.91-2.13A2,2,0,0,0,32,21.1Zm37.37-10L76.24,28.69H57.35V11.06Zm17.4,85.68c-.58-.9-1.64-2.13-1.64-3.2A1.7,1.7,0,0,1,74.26,92c-.05-.9-.09-1.82-.09-2.73,0-.53,0-1.07,0-1.6a4.29,4.29,0,0,1,.18-1,5.74,5.74,0,0,1,2.55-3.25,8,8,0,0,1,1.39-.66c.89-.32.45-1.8,1.41-1.82,2.25-.06,6,2,7.39,3.57a5.69,5.69,0,0,1,1.48,3.7l-.09,3.94a1.29,1.29,0,0,1,.94.81c.31,1.24-1,2.79-1.58,3.78s-2.67,3.87-2.67,3.89a.73.73,0,0,0,.19.45c3.28,4.52,12.93,1.67,12.93,10.65H64.23c0-9,9.65-6.13,12.93-10.64.16-.24.24-.37.23-.47S75,97.1,74.75,96.75Z" />
    </svg>
  ),
  BusinessPlanIcon: (props: React.SVGProps<SVGSVGElement>) => {
    const { mode } = props;
    return (
      <svg {...props} xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 20 20" fill="none">
        <path
          d="M10.8327 4.16667C10.8327 5.08714 8.78065 5.83333 6.24935 5.83333C3.71804 5.83333 1.66602 5.08714 1.66602 4.16667M10.8327 4.16667C10.8327 3.24619 8.78065 2.5 6.24935 2.5C3.71804 2.5 1.66602 3.24619 1.66602 4.16667M10.8327 4.16667V7.88096C9.81476 8.18665 9.16602 8.64911 9.16602 9.16667M1.66602 4.16667V14.1667C1.66602 15.0871 3.71804 15.8333 6.24935 15.8333C7.35737 15.8333 8.37357 15.6904 9.16602 15.4524V9.16667M1.66602 7.5C1.66602 8.42047 3.71804 9.16667 6.24935 9.16667C7.35737 9.16667 8.37357 9.02369 9.16602 8.78571M1.66602 10.8333C1.66602 11.7538 3.71804 12.5 6.24935 12.5C7.35737 12.5 8.37357 12.357 9.16602 12.119M18.3327 9.16667C18.3327 10.0871 16.2807 10.8333 13.7493 10.8333C11.218 10.8333 9.16602 10.0871 9.16602 9.16667M18.3327 9.16667C18.3327 8.24619 16.2807 7.5 13.7493 7.5C11.218 7.5 9.16602 8.24619 9.16602 9.16667M18.3327 9.16667V15.8333C18.3327 16.7538 16.2807 17.5 13.7493 17.5C11.218 17.5 9.16602 16.7538 9.16602 15.8333V9.16667M18.3327 12.5C18.3327 13.4205 16.2807 14.1667 13.7493 14.1667C11.218 14.1667 9.16602 13.4205 9.16602 12.5"
          stroke={mode === "light" ? "black" : "white"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },

  RedirectIcon: (props: React.SVGProps<SVGSVGElement>) => {
    const { mode } = props;
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="none">
        <path
          d="M14 6L14 2M14 2H10M14 2L8.66667 7.33333M6.66667 3.33333H5.2C4.0799 3.33333 3.51984 3.33333 3.09202 3.55132C2.71569 3.74307 2.40973 4.04903 2.21799 4.42535C2 4.85318 2 5.41323 2 6.53333V10.8C2 11.9201 2 12.4802 2.21799 12.908C2.40973 13.2843 2.71569 13.5903 3.09202 13.782C3.51984 14 4.0799 14 5.2 14H9.46667C10.5868 14 11.1468 14 11.5746 13.782C11.951 13.5903 12.2569 13.2843 12.4487 12.908C12.6667 12.4802 12.6667 11.9201 12.6667 10.8V9.33333"
          stroke={mode === "dark" ? "white" : "#09090B"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 6L14 2M14 2H10M14 2L8.66667 7.33333M6.66667 3.33333H5.2C4.0799 3.33333 3.51984 3.33333 3.09202 3.55132C2.71569 3.74307 2.40973 4.04903 2.21799 4.42535C2 4.85318 2 5.41323 2 6.53333V10.8C2 11.9201 2 12.4802 2.21799 12.908C2.40973 13.2843 2.71569 13.5903 3.09202 13.782C3.51984 14 4.0799 14 5.2 14H9.46667C10.5868 14 11.1468 14 11.5746 13.782C11.951 13.5903 12.2569 13.2843 12.4487 12.908C12.6667 12.4802 12.6667 11.9201 12.6667 10.8V9.33333"
          stroke={mode === "dark" ? "white" : "#09090B"}
          strokeOpacity="0.2"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 6L14 2M14 2H10M14 2L8.66667 7.33333M6.66667 3.33333H5.2C4.0799 3.33333 3.51984 3.33333 3.09202 3.55132C2.71569 3.74307 2.40973 4.04903 2.21799 4.42535C2 4.85318 2 5.41323 2 6.53333V10.8C2 11.9201 2 12.4802 2.21799 12.908C2.40973 13.2843 2.71569 13.5903 3.09202 13.782C3.51984 14 4.0799 14 5.2 14H9.46667C10.5868 14 11.1468 14 11.5746 13.782C11.951 13.5903 12.2569 13.2843 12.4487 12.908C12.6667 12.4802 12.6667 11.9201 12.6667 10.8V9.33333"
          stroke={mode === "dark" ? "white" : "#09090B"}
          strokeOpacity="0.2"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },

  ArrowRightIcon: (props: React.SVGProps<SVGSVGElement>) => {
    const { mode, stroke, rotate } = props;
    return (
      <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        style={{ transform: `rotate(${rotate ? rotate : 0}deg)` }}
      >
        <path
          d="M6 12L10 8L6 4"
          stroke={stroke ? stroke : mode === "dark" ? "white" : "black"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },

  CreateAIIcon: (props: React.SVGProps<SVGSVGElement>) => {
    return (
      <svg {...props} width={44} height={26} viewBox="0 0 44 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width={44} height={26} rx={13} fill="#A855F7" fillOpacity="0.2" />
        <path
          d="M9.69602 17H8.2983L11.4389 8.27273H12.9602L16.1009 17H14.7031L12.2358 9.85795H12.1676L9.69602 17ZM9.9304 13.5824H14.4645V14.6903H9.9304V13.5824ZM18.6779 8.27273V17H17.3612V8.27273H18.6779Z"
          fill="#C084FC"
        />
        <g clipPath="url(#clip0_1032_35689)">
          <path
            d="M30.4999 14L28.9999 12.5M31.5051 8.75V8M33.4748 9.53033L34.0051 9M33.4748 13.5L34.0051 14.0303M29.5051 9.53033L28.9748 9M34.2551 11.5H35.0051M27.0656 17.4343L31.6842 12.8157C31.8822 12.6177 31.9813 12.5187 32.0183 12.4045C32.051 12.3041 32.051 12.1959 32.0183 12.0955C31.9813 11.9813 31.8822 11.8823 31.6842 11.6843L31.3156 11.3157C31.1176 11.1177 31.0186 11.0187 30.9044 10.9816C30.804 10.9489 30.6958 10.9489 30.5954 10.9816C30.4813 11.0187 30.3822 11.1177 30.1842 11.3157L25.5656 15.9343C25.3676 16.1323 25.2686 16.2313 25.2315 16.3455C25.1989 16.4459 25.1989 16.5541 25.2315 16.6545C25.2686 16.7687 25.3676 16.8677 25.5656 17.0657L25.9342 17.4343C26.1322 17.6323 26.2313 17.7313 26.3454 17.7684C26.4458 17.8011 26.554 17.8011 26.6544 17.7684C26.7686 17.7313 26.8676 17.6323 27.0656 17.4343Z"
            stroke="#C084FC"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1032_35689">
            <rect width={12} height={12} fill="white" transform="translate(24 7)" />
          </clipPath>
        </defs>
      </svg>
    );
  },

  ChevronUpDoubleIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none">
      <path
        d="M14.1667 15L10 10.8333L5.83337 15M14.1667 9.16667L10 5L5.83337 9.16667"
        stroke="#A855F7"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  AlertCircleIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none">
      <g clipPath="url(#clip0_961_17518)">
        <path
          d="M10 6.66675V10.0001M10 13.3334H10.0084M18.3334 10.0001C18.3334 14.6025 14.6024 18.3334 10 18.3334C5.39765 18.3334 1.66669 14.6025 1.66669 10.0001C1.66669 5.39771 5.39765 1.66675 10 1.66675C14.6024 1.66675 18.3334 5.39771 18.3334 10.0001Z"
          stroke="#EF5656"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_961_17518">
          <rect width={20} height={20} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  UserBadgeIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x={1} y={1} width={22} height={22} rx={11} fill="#A855F7" />
      <rect x={1} y={1} width={22} height={22} rx={11} stroke="#D4D4D8" strokeWidth={2} />
      <path
        d="M9.98334 13.361L9.5 17L11.7942 15.6235C11.869 15.5786 11.9064 15.5561 11.9464 15.5474C11.9817 15.5396 12.0183 15.5396 12.0536 15.5474C12.0936 15.5561 12.131 15.5786 12.2058 15.6235L14.5 17L14.0171 13.3606M15.5 10.5C15.5 12.433 13.933 14 12 14C10.067 14 8.5 12.433 8.5 10.5C8.5 8.567 10.067 7 12 7C13.933 7 15.5 8.567 15.5 10.5Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  UserTreeIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x={1} y={1} width={22} height={22} rx={11} fill="#D4D4D8" />
      <rect x={1} y={1} width={22} height={22} rx={11} stroke="#D4D4D8" strokeWidth={2} />
      <path
        d="M14.5 16H14.4C13.5599 16 13.1399 16 12.819 15.8365C12.5368 15.6927 12.3073 15.4632 12.1635 15.181C12 14.8601 12 14.4401 12 13.6V10.4C12 9.55992 12 9.13988 12.1635 8.81901C12.3073 8.53677 12.5368 8.3073 12.819 8.16349C13.1399 8 13.5599 8 14.4 8H14.5M14.5 16C14.5 16.5523 14.9477 17 15.5 17C16.0523 17 16.5 16.5523 16.5 16C16.5 15.4477 16.0523 15 15.5 15C14.9477 15 14.5 15.4477 14.5 16ZM14.5 8C14.5 8.55228 14.9477 9 15.5 9C16.0523 9 16.5 8.55228 16.5 8C16.5 7.44772 16.0523 7 15.5 7C14.9477 7 14.5 7.44772 14.5 8ZM9.5 12L14.5 12M9.5 12C9.5 12.5523 9.05228 13 8.5 13C7.94772 13 7.5 12.5523 7.5 12C7.5 11.4477 7.94772 11 8.5 11C9.05228 11 9.5 11.4477 9.5 12ZM14.5 12C14.5 12.5523 14.9477 13 15.5 13C16.0523 13 16.5 12.5523 16.5 12C16.5 11.4477 16.0523 11 15.5 11C14.9477 11 14.5 11.4477 14.5 12Z"
        stroke="#52525B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  CampaignsIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.99967 2.99967C8.45991 2.99967 8.83301 2.62658 8.83301 2.16634C8.83301 1.7061 8.45991 1.33301 7.99967 1.33301C7.53944 1.33301 7.16634 1.7061 7.16634 2.16634C7.16634 2.62658 7.53944 2.99967 7.99967 2.99967Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99967 2.99967C8.45991 2.99967 8.83301 2.62658 8.83301 2.16634C8.83301 1.7061 8.45991 1.33301 7.99967 1.33301C7.53944 1.33301 7.16634 1.7061 7.16634 2.16634C7.16634 2.62658 7.53944 2.99967 7.99967 2.99967Z"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99967 2.99967C8.45991 2.99967 8.83301 2.62658 8.83301 2.16634C8.83301 1.7061 8.45991 1.33301 7.99967 1.33301C7.53944 1.33301 7.16634 1.7061 7.16634 2.16634C7.16634 2.62658 7.53944 2.99967 7.99967 2.99967Z"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99967 8.83301C8.45991 8.83301 8.83301 8.45991 8.83301 7.99967C8.83301 7.53944 8.45991 7.16634 7.99967 7.16634C7.53944 7.16634 7.16634 7.53944 7.16634 7.99967C7.16634 8.45991 7.53944 8.83301 7.99967 8.83301Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99967 8.83301C8.45991 8.83301 8.83301 8.45991 8.83301 7.99967C8.83301 7.53944 8.45991 7.16634 7.99967 7.16634C7.53944 7.16634 7.16634 7.53944 7.16634 7.99967C7.16634 8.45991 7.53944 8.83301 7.99967 8.83301Z"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99967 8.83301C8.45991 8.83301 8.83301 8.45991 8.83301 7.99967C8.83301 7.53944 8.45991 7.16634 7.99967 7.16634C7.53944 7.16634 7.16634 7.53944 7.16634 7.99967C7.16634 8.45991 7.53944 8.83301 7.99967 8.83301Z"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99967 14.6663C8.45991 14.6663 8.83301 14.2932 8.83301 13.833C8.83301 13.3728 8.45991 12.9997 7.99967 12.9997C7.53944 12.9997 7.16634 13.3728 7.16634 13.833C7.16634 14.2932 7.53944 14.6663 7.99967 14.6663Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99967 14.6663C8.45991 14.6663 8.83301 14.2932 8.83301 13.833C8.83301 13.3728 8.45991 12.9997 7.99967 12.9997C7.53944 12.9997 7.16634 13.3728 7.16634 13.833C7.16634 14.2932 7.53944 14.6663 7.99967 14.6663Z"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99967 14.6663C8.45991 14.6663 8.83301 14.2932 8.83301 13.833C8.83301 13.3728 8.45991 12.9997 7.99967 12.9997C7.53944 12.9997 7.16634 13.3728 7.16634 13.833C7.16634 14.2932 7.53944 14.6663 7.99967 14.6663Z"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.833 2.99967C14.2932 2.99967 14.6663 2.62658 14.6663 2.16634C14.6663 1.7061 14.2932 1.33301 13.833 1.33301C13.3728 1.33301 12.9997 1.7061 12.9997 2.16634C12.9997 2.62658 13.3728 2.99967 13.833 2.99967Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.833 2.99967C14.2932 2.99967 14.6663 2.62658 14.6663 2.16634C14.6663 1.7061 14.2932 1.33301 13.833 1.33301C13.3728 1.33301 12.9997 1.7061 12.9997 2.16634C12.9997 2.62658 13.3728 2.99967 13.833 2.99967Z"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.833 2.99967C14.2932 2.99967 14.6663 2.62658 14.6663 2.16634C14.6663 1.7061 14.2932 1.33301 13.833 1.33301C13.3728 1.33301 12.9997 1.7061 12.9997 2.16634C12.9997 2.62658 13.3728 2.99967 13.833 2.99967Z"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.833 8.83301C14.2932 8.83301 14.6663 8.45991 14.6663 7.99967C14.6663 7.53944 14.2932 7.16634 13.833 7.16634C13.3728 7.16634 12.9997 7.53944 12.9997 7.99967C12.9997 8.45991 13.3728 8.83301 13.833 8.83301Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.833 8.83301C14.2932 8.83301 14.6663 8.45991 14.6663 7.99967C14.6663 7.53944 14.2932 7.16634 13.833 7.16634C13.3728 7.16634 12.9997 7.53944 12.9997 7.99967C12.9997 8.45991 13.3728 8.83301 13.833 8.83301Z"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.833 8.83301C14.2932 8.83301 14.6663 8.45991 14.6663 7.99967C14.6663 7.53944 14.2932 7.16634 13.833 7.16634C13.3728 7.16634 12.9997 7.53944 12.9997 7.99967C12.9997 8.45991 13.3728 8.83301 13.833 8.83301Z"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.833 14.6663C14.2932 14.6663 14.6663 14.2932 14.6663 13.833C14.6663 13.3728 14.2932 12.9997 13.833 12.9997C13.3728 12.9997 12.9997 13.3728 12.9997 13.833C12.9997 14.2932 13.3728 14.6663 13.833 14.6663Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.833 14.6663C14.2932 14.6663 14.6663 14.2932 14.6663 13.833C14.6663 13.3728 14.2932 12.9997 13.833 12.9997C13.3728 12.9997 12.9997 13.3728 12.9997 13.833C12.9997 14.2932 13.3728 14.6663 13.833 14.6663Z"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.833 14.6663C14.2932 14.6663 14.6663 14.2932 14.6663 13.833C14.6663 13.3728 14.2932 12.9997 13.833 12.9997C13.3728 12.9997 12.9997 13.3728 12.9997 13.833C12.9997 14.2932 13.3728 14.6663 13.833 14.6663Z"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.16634 2.99967C2.62658 2.99967 2.99967 2.62658 2.99967 2.16634C2.99967 1.7061 2.62658 1.33301 2.16634 1.33301C1.7061 1.33301 1.33301 1.7061 1.33301 2.16634C1.33301 2.62658 1.7061 2.99967 2.16634 2.99967Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.16634 2.99967C2.62658 2.99967 2.99967 2.62658 2.99967 2.16634C2.99967 1.7061 2.62658 1.33301 2.16634 1.33301C1.7061 1.33301 1.33301 1.7061 1.33301 2.16634C1.33301 2.62658 1.7061 2.99967 2.16634 2.99967Z"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.16634 2.99967C2.62658 2.99967 2.99967 2.62658 2.99967 2.16634C2.99967 1.7061 2.62658 1.33301 2.16634 1.33301C1.7061 1.33301 1.33301 1.7061 1.33301 2.16634C1.33301 2.62658 1.7061 2.99967 2.16634 2.99967Z"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.16634 8.83301C2.62658 8.83301 2.99967 8.45991 2.99967 7.99967C2.99967 7.53944 2.62658 7.16634 2.16634 7.16634C1.7061 7.16634 1.33301 7.53944 1.33301 7.99967C1.33301 8.45991 1.7061 8.83301 2.16634 8.83301Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.16634 8.83301C2.62658 8.83301 2.99967 8.45991 2.99967 7.99967C2.99967 7.53944 2.62658 7.16634 2.16634 7.16634C1.7061 7.16634 1.33301 7.53944 1.33301 7.99967C1.33301 8.45991 1.7061 8.83301 2.16634 8.83301Z"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.16634 8.83301C2.62658 8.83301 2.99967 8.45991 2.99967 7.99967C2.99967 7.53944 2.62658 7.16634 2.16634 7.16634C1.7061 7.16634 1.33301 7.53944 1.33301 7.99967C1.33301 8.45991 1.7061 8.83301 2.16634 8.83301Z"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.16634 14.6663C2.62658 14.6663 2.99967 14.2932 2.99967 13.833C2.99967 13.3728 2.62658 12.9997 2.16634 12.9997C1.7061 12.9997 1.33301 13.3728 1.33301 13.833C1.33301 14.2932 1.7061 14.6663 2.16634 14.6663Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.16634 14.6663C2.62658 14.6663 2.99967 14.2932 2.99967 13.833C2.99967 13.3728 2.62658 12.9997 2.16634 12.9997C1.7061 12.9997 1.33301 13.3728 1.33301 13.833C1.33301 14.2932 1.7061 14.6663 2.16634 14.6663Z"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.16634 14.6663C2.62658 14.6663 2.99967 14.2932 2.99967 13.833C2.99967 13.3728 2.62658 12.9997 2.16634 12.9997C1.7061 12.9997 1.33301 13.3728 1.33301 13.833C1.33301 14.2932 1.7061 14.6663 2.16634 14.6663Z"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  WalletIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="wallet-01">
        <path
          id="Icon"
          d="M18.3333 7.08337H1.66663M1.66663 10.4167H4.62219C5.07235 10.4167 5.29743 10.4167 5.51507 10.4555C5.70825 10.4899 5.89671 10.547 6.07655 10.6255C6.27916 10.714 6.46644 10.8388 6.84099 11.0885L7.32559 11.4116C7.70015 11.6613 7.88743 11.7861 8.09004 11.8746C8.26988 11.9531 8.45833 12.0101 8.65151 12.0446C8.86916 12.0834 9.09424 12.0834 9.5444 12.0834H10.4555C10.9057 12.0834 11.1308 12.0834 11.3484 12.0446C11.5416 12.0101 11.73 11.9531 11.9099 11.8746C12.1125 11.7861 12.2998 11.6613 12.6743 11.4116L13.1589 11.0885C13.5335 10.8388 13.7208 10.714 13.9234 10.6255C14.1032 10.547 14.2917 10.4899 14.4848 10.4555C14.7025 10.4167 14.9276 10.4167 15.3777 10.4167H18.3333M1.66663 6.00004L1.66663 14C1.66663 14.9335 1.66663 15.4002 1.84828 15.7567C2.00807 16.0703 2.26304 16.3253 2.57664 16.485C2.93316 16.6667 3.39987 16.6667 4.33329 16.6667L15.6666 16.6667C16.6 16.6667 17.0668 16.6667 17.4233 16.4851C17.7369 16.3253 17.9919 16.0703 18.1516 15.7567C18.3333 15.4002 18.3333 14.9335 18.3333 14V6.00004C18.3333 5.06662 18.3333 4.59991 18.1516 4.24339C17.9919 3.92979 17.7369 3.67482 17.4233 3.51503C17.0668 3.33338 16.6 3.33338 15.6666 3.33338L4.33329 3.33337C3.39987 3.33337 2.93316 3.33337 2.57664 3.51503C2.26304 3.67482 2.00807 3.92979 1.84828 4.24339C1.66663 4.59991 1.66663 5.06662 1.66663 6.00004Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
  AnalyticsIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width={18} height={18} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.5 16.5H4.16667C3.23325 16.5 2.76654 16.5 2.41002 16.3183C2.09641 16.1586 1.84144 15.9036 1.68166 15.59C1.5 15.2335 1.5 14.7668 1.5 13.8333V1.5M4.83333 7.75V13.5833M8.58333 3.58333V13.5833M12.3333 7.75V13.5833M16.0833 3.58333V13.5833"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 16.5H4.16667C3.23325 16.5 2.76654 16.5 2.41002 16.3183C2.09641 16.1586 1.84144 15.9036 1.68166 15.59C1.5 15.2335 1.5 14.7668 1.5 13.8333V1.5M4.83333 7.75V13.5833M8.58333 3.58333V13.5833M12.3333 7.75V13.5833M16.0833 3.58333V13.5833"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 16.5H4.16667C3.23325 16.5 2.76654 16.5 2.41002 16.3183C2.09641 16.1586 1.84144 15.9036 1.68166 15.59C1.5 15.2335 1.5 14.7668 1.5 13.8333V1.5M4.83333 7.75V13.5833M8.58333 3.58333V13.5833M12.3333 7.75V13.5833M16.0833 3.58333V13.5833"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  ProfileIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width={18} height={17} viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.5 15.6667C3.44649 13.6021 6.08918 12.3333 9 12.3333C11.9108 12.3333 14.5535 13.6021 16.5 15.6667M12.75 5.25C12.75 7.32107 11.0711 9 9 9C6.92893 9 5.25 7.32107 5.25 5.25C5.25 3.17893 6.92893 1.5 9 1.5C11.0711 1.5 12.75 3.17893 12.75 5.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 15.6667C3.44649 13.6021 6.08918 12.3333 9 12.3333C11.9108 12.3333 14.5535 13.6021 16.5 15.6667M12.75 5.25C12.75 7.32107 11.0711 9 9 9C6.92893 9 5.25 7.32107 5.25 5.25C5.25 3.17893 6.92893 1.5 9 1.5C11.0711 1.5 12.75 3.17893 12.75 5.25Z"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 15.6667C3.44649 13.6021 6.08918 12.3333 9 12.3333C11.9108 12.3333 14.5535 13.6021 16.5 15.6667M12.75 5.25C12.75 7.32107 11.0711 9 9 9C6.92893 9 5.25 7.32107 5.25 5.25C5.25 3.17893 6.92893 1.5 9 1.5C11.0711 1.5 12.75 3.17893 12.75 5.25Z"
        strokeOpacity="0.2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  BalanceIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width={20} height={16} viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.3337 5.08301H1.66699M1.66699 8.41634H4.62256C5.07272 8.41634 5.29779 8.41634 5.51544 8.45514C5.70862 8.48957 5.89708 8.54663 6.07691 8.62514C6.27953 8.71358 6.4668 8.83844 6.84136 9.08814L7.32596 9.41121C7.70052 9.66091 7.88779 9.78576 8.0904 9.87421C8.27024 9.95272 8.4587 10.0098 8.65188 10.0442C8.86952 10.083 9.0946 10.083 9.54476 10.083H10.4559C10.906 10.083 11.1311 10.083 11.3488 10.0442C11.542 10.0098 11.7304 9.95272 11.9102 9.87421C12.1129 9.78576 12.3001 9.66091 12.6747 9.41121L13.1593 9.08814C13.5338 8.83844 13.7211 8.71358 13.9237 8.62514C14.1036 8.54663 14.292 8.48957 14.4852 8.45514C14.7029 8.41634 14.9279 8.41634 15.3781 8.41634H18.3337M1.66699 3.99967L1.66699 11.9997C1.66699 12.9331 1.66699 13.3998 1.84865 13.7563C2.00844 14.0699 2.2634 14.3249 2.57701 14.4847C2.93353 14.6663 3.40024 14.6663 4.33366 14.6663L15.667 14.6663C16.6004 14.6663 17.0671 14.6663 17.4236 14.4847C17.7372 14.3249 17.9922 14.0699 18.152 13.7563C18.3337 13.3998 18.3337 12.9331 18.3337 11.9997V3.99968C18.3337 3.06625 18.3337 2.59954 18.152 2.24302C17.9922 1.92942 17.7372 1.67445 17.4236 1.51466C17.0671 1.33301 16.6004 1.33301 15.667 1.33301L4.33366 1.33301C3.40024 1.33301 2.93353 1.33301 2.57701 1.51466C2.2634 1.67445 2.00844 1.92942 1.84865 2.24302C1.66699 2.59954 1.66699 3.06625 1.66699 3.99967Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3337 5.08301H1.66699M1.66699 8.41634H4.62256C5.07272 8.41634 5.29779 8.41634 5.51544 8.45514C5.70862 8.48957 5.89708 8.54663 6.07691 8.62514C6.27953 8.71358 6.4668 8.83844 6.84136 9.08814L7.32596 9.41121C7.70052 9.66091 7.88779 9.78576 8.0904 9.87421C8.27024 9.95272 8.4587 10.0098 8.65188 10.0442C8.86952 10.083 9.0946 10.083 9.54476 10.083H10.4559C10.906 10.083 11.1311 10.083 11.3488 10.0442C11.542 10.0098 11.7304 9.95272 11.9102 9.87421C12.1129 9.78576 12.3001 9.66091 12.6747 9.41121L13.1593 9.08814C13.5338 8.83844 13.7211 8.71358 13.9237 8.62514C14.1036 8.54663 14.292 8.48957 14.4852 8.45514C14.7029 8.41634 14.9279 8.41634 15.3781 8.41634H18.3337M1.66699 3.99967L1.66699 11.9997C1.66699 12.9331 1.66699 13.3998 1.84865 13.7563C2.00844 14.0699 2.2634 14.3249 2.57701 14.4847C2.93353 14.6663 3.40024 14.6663 4.33366 14.6663L15.667 14.6663C16.6004 14.6663 17.0671 14.6663 17.4236 14.4847C17.7372 14.3249 17.9922 14.0699 18.152 13.7563C18.3337 13.3998 18.3337 12.9331 18.3337 11.9997V3.99968C18.3337 3.06625 18.3337 2.59954 18.152 2.24302C17.9922 1.92942 17.7372 1.67445 17.4236 1.51466C17.0671 1.33301 16.6004 1.33301 15.667 1.33301L4.33366 1.33301C3.40024 1.33301 2.93353 1.33301 2.57701 1.51466C2.2634 1.67445 2.00844 1.92942 1.84865 2.24302C1.66699 2.59954 1.66699 3.06625 1.66699 3.99967Z"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3337 5.08301H1.66699M1.66699 8.41634H4.62256C5.07272 8.41634 5.29779 8.41634 5.51544 8.45514C5.70862 8.48957 5.89708 8.54663 6.07691 8.62514C6.27953 8.71358 6.4668 8.83844 6.84136 9.08814L7.32596 9.41121C7.70052 9.66091 7.88779 9.78576 8.0904 9.87421C8.27024 9.95272 8.4587 10.0098 8.65188 10.0442C8.86952 10.083 9.0946 10.083 9.54476 10.083H10.4559C10.906 10.083 11.1311 10.083 11.3488 10.0442C11.542 10.0098 11.7304 9.95272 11.9102 9.87421C12.1129 9.78576 12.3001 9.66091 12.6747 9.41121L13.1593 9.08814C13.5338 8.83844 13.7211 8.71358 13.9237 8.62514C14.1036 8.54663 14.292 8.48957 14.4852 8.45514C14.7029 8.41634 14.9279 8.41634 15.3781 8.41634H18.3337M1.66699 3.99967L1.66699 11.9997C1.66699 12.9331 1.66699 13.3998 1.84865 13.7563C2.00844 14.0699 2.2634 14.3249 2.57701 14.4847C2.93353 14.6663 3.40024 14.6663 4.33366 14.6663L15.667 14.6663C16.6004 14.6663 17.0671 14.6663 17.4236 14.4847C17.7372 14.3249 17.9922 14.0699 18.152 13.7563C18.3337 13.3998 18.3337 12.9331 18.3337 11.9997V3.99968C18.3337 3.06625 18.3337 2.59954 18.152 2.24302C17.9922 1.92942 17.7372 1.67445 17.4236 1.51466C17.0671 1.33301 16.6004 1.33301 15.667 1.33301L4.33366 1.33301C3.40024 1.33301 2.93353 1.33301 2.57701 1.51466C2.2634 1.67445 2.00844 1.92942 1.84865 2.24302C1.66699 2.59954 1.66699 3.06625 1.66699 3.99967Z"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  SettingsIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="settings-01" clipPath="url(#clip0_2763_8860)">
        <g id="Icon">
          <path
            d="M9.99996 12.5C11.3807 12.5 12.5 11.3807 12.5 9.99996C12.5 8.61925 11.3807 7.49996 9.99996 7.49996C8.61925 7.49996 7.49996 8.61925 7.49996 9.99996C7.49996 11.3807 8.61925 12.5 9.99996 12.5Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.606 12.2727C15.5052 12.5012 15.4751 12.7547 15.5197 13.0004C15.5642 13.2462 15.6814 13.4729 15.856 13.6515L15.9015 13.6969C16.0423 13.8376 16.1541 14.0048 16.2304 14.1887C16.3066 14.3726 16.3458 14.5698 16.3458 14.7689C16.3458 14.968 16.3066 15.1652 16.2304 15.3491C16.1541 15.533 16.0423 15.7002 15.9015 15.8409C15.7608 15.9817 15.5937 16.0935 15.4097 16.1697C15.2258 16.246 15.0286 16.2852 14.8295 16.2852C14.6304 16.2852 14.4332 16.246 14.2493 16.1697C14.0654 16.0935 13.8983 15.9817 13.7575 15.8409L13.7121 15.7954C13.5335 15.6208 13.3068 15.5036 13.061 15.459C12.8153 15.4145 12.5618 15.4446 12.3333 15.5454C12.1092 15.6414 11.9181 15.8009 11.7835 16.0042C11.6489 16.2074 11.5767 16.4456 11.5757 16.6894V16.8181C11.5757 17.22 11.4161 17.6054 11.1319 17.8895C10.8478 18.1737 10.4624 18.3333 10.0606 18.3333C9.65872 18.3333 9.27334 18.1737 8.98919 17.8895C8.70505 17.6054 8.54541 17.22 8.54541 16.8181V16.75C8.53955 16.4992 8.45838 16.256 8.31247 16.052C8.16655 15.848 7.96264 15.6926 7.72723 15.606C7.49874 15.5052 7.24527 15.4751 6.99951 15.5197C6.75376 15.5642 6.52699 15.6814 6.34844 15.856L6.30299 15.9015C6.16227 16.0423 5.99517 16.1541 5.81123 16.2304C5.6273 16.3066 5.43013 16.3458 5.23102 16.3458C5.03191 16.3458 4.83474 16.3066 4.65081 16.2304C4.46687 16.1541 4.29977 16.0423 4.15905 15.9015C4.01818 15.7608 3.90642 15.5937 3.83017 15.4097C3.75392 15.2258 3.71468 15.0286 3.71468 14.8295C3.71468 14.6304 3.75392 14.4332 3.83017 14.2493C3.90642 14.0654 4.01818 13.8983 4.15905 13.7575L4.2045 13.7121C4.37915 13.5335 4.49631 13.3068 4.54087 13.061C4.58543 12.8153 4.55535 12.5618 4.4545 12.3333C4.35847 12.1092 4.19902 11.9181 3.99577 11.7835C3.79252 11.6489 3.55434 11.5767 3.31057 11.5757H3.18178C2.77993 11.5757 2.39455 11.4161 2.1104 11.1319C1.82626 10.8478 1.66663 10.4624 1.66663 10.0606C1.66663 9.65872 1.82626 9.27334 2.1104 8.98919C2.39455 8.70505 2.77993 8.54541 3.18178 8.54541H3.24996C3.50071 8.53955 3.7439 8.45838 3.94791 8.31247C4.15192 8.16655 4.30732 7.96264 4.3939 7.72723C4.49474 7.49874 4.52483 7.24527 4.48027 6.99951C4.43571 6.75376 4.31855 6.52699 4.1439 6.34844L4.09844 6.30299C3.95757 6.16227 3.84581 5.99517 3.76957 5.81123C3.69332 5.6273 3.65407 5.43013 3.65407 5.23102C3.65407 5.03191 3.69332 4.83474 3.76957 4.65081C3.84581 4.46687 3.95757 4.29977 4.09844 4.15905C4.23916 4.01818 4.40627 3.90642 4.5902 3.83017C4.77414 3.75392 4.9713 3.71468 5.17041 3.71468C5.36953 3.71468 5.56669 3.75392 5.75063 3.83017C5.93456 3.90642 6.10167 4.01818 6.24238 4.15905L6.28784 4.2045C6.46638 4.37915 6.69315 4.49631 6.93891 4.54087C7.18466 4.58543 7.43813 4.55535 7.66663 4.4545H7.72723C7.9513 4.35847 8.1424 4.19902 8.277 3.99577C8.4116 3.79252 8.48384 3.55434 8.48481 3.31057V3.18178C8.48481 2.77993 8.64444 2.39455 8.92859 2.1104C9.21273 1.82626 9.59812 1.66663 9.99996 1.66663C10.4018 1.66663 10.7872 1.82626 11.0713 2.1104C11.3555 2.39455 11.5151 2.77993 11.5151 3.18178V3.24996C11.5161 3.49374 11.5883 3.73191 11.7229 3.93516C11.8575 4.13841 12.0486 4.29787 12.2727 4.3939C12.5012 4.49474 12.7547 4.52483 13.0004 4.48027C13.2462 4.43571 13.4729 4.31855 13.6515 4.1439L13.6969 4.09844C13.8376 3.95757 14.0048 3.84581 14.1887 3.76957C14.3726 3.69332 14.5698 3.65407 14.7689 3.65407C14.968 3.65407 15.1652 3.69332 15.3491 3.76957C15.533 3.84581 15.7002 3.95757 15.8409 4.09844C15.9817 4.23916 16.0935 4.40627 16.1697 4.5902C16.246 4.77414 16.2852 4.9713 16.2852 5.17041C16.2852 5.36953 16.246 5.56669 16.1697 5.75063C16.0935 5.93456 15.9817 6.10167 15.8409 6.24238L15.7954 6.28784C15.6208 6.46638 15.5036 6.69315 15.459 6.93891C15.4145 7.18466 15.4446 7.43813 15.5454 7.66663V7.72723C15.6414 7.9513 15.8009 8.1424 16.0042 8.277C16.2074 8.4116 16.4456 8.48384 16.6894 8.48481H16.8181C17.22 8.48481 17.6054 8.64444 17.8895 8.92859C18.1737 9.21273 18.3333 9.59812 18.3333 9.99996C18.3333 10.4018 18.1737 10.7872 17.8895 11.0713C17.6054 11.3555 17.22 11.5151 16.8181 11.5151H16.75C16.5062 11.5161 16.268 11.5883 16.0648 11.7229C15.8615 11.8575 15.7021 12.0486 15.606 12.2727Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2763_8860">
          <rect width="20" height="20" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  ),
  SubscriptionIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="refresh-ccw-05">
        <path
          id="Icon"
          d="M7.12221 16.4729C9.12149 17.3599 11.5027 17.3117 13.5419 16.1344C16.9298 14.1784 18.0906 9.8463 16.1345 6.4584L15.9262 6.09755M3.86546 13.5418C1.90945 10.1539 3.07024 5.82183 6.45814 3.86582C8.4973 2.68851 10.8785 2.64034 12.8778 3.52731M2.07788 13.6115L4.35459 14.2216L4.96463 11.9449M15.0356 8.05491L15.6456 5.77821L17.9223 6.38825"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
  ReferralIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="user-plus-01">
        <path
          id="Icon"
          d="M9.99996 12.9167H6.24996C5.08699 12.9167 4.5055 12.9167 4.03234 13.0602C2.96701 13.3834 2.13333 14.217 1.81016 15.2824C1.66663 15.7555 1.66663 16.337 1.66663 17.5M15.8333 17.5V12.5M13.3333 15H18.3333M12.0833 6.25C12.0833 8.32107 10.4044 10 8.33329 10C6.26222 10 4.58329 8.32107 4.58329 6.25C4.58329 4.17893 6.26222 2.5 8.33329 2.5C10.4044 2.5 12.0833 4.17893 12.0833 6.25Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
  UsersIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.3337 2.8898C14.5684 3.50343 15.417 4.77762 15.417 6.25C15.417 7.72238 14.5684 8.99657 13.3337 9.6102M15.0003 13.972C16.2599 14.5419 17.3941 15.4708 18.3337 16.6667M1.66699 16.6667C3.28907 14.6021 5.49131 13.3333 7.91699 13.3333C10.3427 13.3333 12.5449 14.6021 14.167 16.6667M11.667 6.25C11.667 8.32107 9.98806 10 7.91699 10C5.84592 10 4.16699 8.32107 4.16699 6.25C4.16699 4.17893 5.84592 2.5 7.91699 2.5C9.98806 2.5 11.667 4.17893 11.667 6.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3337 2.8898C14.5684 3.50343 15.417 4.77762 15.417 6.25C15.417 7.72238 14.5684 8.99657 13.3337 9.6102M15.0003 13.972C16.2599 14.5419 17.3941 15.4708 18.3337 16.6667M1.66699 16.6667C3.28907 14.6021 5.49131 13.3333 7.91699 13.3333C10.3427 13.3333 12.5449 14.6021 14.167 16.6667M11.667 6.25C11.667 8.32107 9.98806 10 7.91699 10C5.84592 10 4.16699 8.32107 4.16699 6.25C4.16699 4.17893 5.84592 2.5 7.91699 2.5C9.98806 2.5 11.667 4.17893 11.667 6.25Z"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3337 2.8898C14.5684 3.50343 15.417 4.77762 15.417 6.25C15.417 7.72238 14.5684 8.99657 13.3337 9.6102M15.0003 13.972C16.2599 14.5419 17.3941 15.4708 18.3337 16.6667M1.66699 16.6667C3.28907 14.6021 5.49131 13.3333 7.91699 13.3333C10.3427 13.3333 12.5449 14.6021 14.167 16.6667M11.667 6.25C11.667 8.32107 9.98806 10 7.91699 10C5.84592 10 4.16699 8.32107 4.16699 6.25C4.16699 4.17893 5.84592 2.5 7.91699 2.5C9.98806 2.5 11.667 4.17893 11.667 6.25Z"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  MediaIcon: (props: React.SVGProps<SVGSVGElement>) => {
    return (
      <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="image-01">
          <path
            id="Icon"
            d="M13.5 17.5H5.77614C5.2713 17.5 5.01887 17.5 4.90199 17.4002C4.80056 17.3135 4.74674 17.1836 4.75721 17.0506C4.76927 16.8974 4.94776 16.7189 5.30474 16.3619L12.3905 9.27614C12.7205 8.94613 12.8855 8.78112 13.0758 8.7193C13.2432 8.66492 13.4235 8.66492 13.5908 8.7193C13.7811 8.78112 13.9461 8.94613 14.2761 9.27614L17.5 12.5V13.5M13.5 17.5C14.9001 17.5 15.6002 17.5 16.135 17.2275C16.6054 16.9878 16.9878 16.6054 17.2275 16.135C17.5 15.6002 17.5 14.9001 17.5 13.5M13.5 17.5H6.5C5.09987 17.5 4.3998 17.5 3.86502 17.2275C3.39462 16.9878 3.01217 16.6054 2.77248 16.135C2.5 15.6002 2.5 14.9001 2.5 13.5V6.5C2.5 5.09987 2.5 4.3998 2.77248 3.86502C3.01217 3.39462 3.39462 3.01217 3.86502 2.77248C4.3998 2.5 5.09987 2.5 6.5 2.5H13.5C14.9001 2.5 15.6002 2.5 16.135 2.77248C16.6054 3.01217 16.9878 3.39462 17.2275 3.86502C17.5 4.3998 17.5 5.09987 17.5 6.5V13.5M8.75 7.08333C8.75 8.00381 8.00381 8.75 7.08333 8.75C6.16286 8.75 5.41667 8.00381 5.41667 7.08333C5.41667 6.16286 6.16286 5.41667 7.08333 5.41667C8.00381 5.41667 8.75 6.16286 8.75 7.08333Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    );
  },
  InfoIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_1934_75207)">
        <path
          d="M8.00004 10.6667V8.00004M8.00004 5.33337H8.00671M14.6667 8.00004C14.6667 11.6819 11.6819 14.6667 8.00004 14.6667C4.31814 14.6667 1.33337 11.6819 1.33337 8.00004C1.33337 4.31814 4.31814 1.33337 8.00004 1.33337C11.6819 1.33337 14.6667 4.31814 14.6667 8.00004Z"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1934_75207">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  AnnouncementIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="announcement-03">
        <path
          id="Icon"
          d="M15.4167 13.3333C17.0276 13.3333 18.3334 10.9082 18.3334 7.91667C18.3334 4.92512 17.0276 2.5 15.4167 2.5M15.4167 13.3333C13.8059 13.3333 12.5001 10.9082 12.5001 7.91667C12.5001 4.92512 13.8059 2.5 15.4167 2.5M15.4167 13.3333L4.53637 11.3551C3.76346 11.2146 3.377 11.1443 3.06452 10.9908C2.42881 10.6785 1.95538 10.1113 1.76187 9.42994C1.66675 9.09504 1.66675 8.70225 1.66675 7.91667C1.66675 7.13108 1.66675 6.73829 1.76187 6.40339C1.95538 5.72207 2.42881 5.15481 3.06452 4.84254C3.377 4.68904 3.76346 4.61878 4.53637 4.47825L15.4167 2.5M4.16675 11.6667L4.49496 16.2617C4.52613 16.698 4.54172 16.9162 4.63664 17.0816C4.72022 17.2272 4.84582 17.3441 4.99699 17.4171C5.16868 17.5 5.38743 17.5 5.82491 17.5H7.31024C7.81037 17.5 8.06043 17.5 8.24551 17.4003C8.40814 17.3126 8.53703 17.1734 8.61194 17.0046C8.69719 16.8124 8.67801 16.5631 8.63965 16.0644L8.33341 12.0833"
          stroke="white"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
  SearchIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M14 14L10.0001 10M11.3333 6.66667C11.3333 9.244 9.244 11.3333 6.66667 11.3333C4.08934 11.3333 2 9.244 2 6.66667C2 4.08934 4.08934 2 6.66667 2C9.244 2 11.3333 4.08934 11.3333 6.66667Z"
        stroke="#A1A1AA"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  ShoppingBagIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="shopping-bag-03">
        <path
          id="Icon"
          d="M13.3329 6.66667C13.3329 7.55072 12.9817 8.39857 12.3566 9.02369C11.7315 9.64881 10.8836 10 9.99958 10C9.11552 10 8.26767 9.64881 7.64255 9.02369C7.01743 8.39857 6.66624 7.55072 6.66624 6.66667M3.02726 6.16782L2.44392 13.1678C2.31861 14.6716 2.25595 15.4235 2.51015 16.0035C2.73348 16.5131 3.12043 16.9336 3.60973 17.1985C4.16664 17.5 4.92113 17.5 6.43011 17.5H13.569C15.078 17.5 15.8325 17.5 16.3894 17.1985C16.8787 16.9336 17.2657 16.5131 17.489 16.0035C17.7432 15.4235 17.6805 14.6716 17.5552 13.1678L16.9719 6.16782C16.8641 4.87396 16.8102 4.22703 16.5236 3.73738C16.2713 3.3062 15.8956 2.9605 15.445 2.74487C14.9332 2.5 14.2841 2.5 12.9857 2.5L7.01344 2.5C5.7151 2.5 5.06592 2.5 4.55417 2.74487C4.10353 2.9605 3.72782 3.3062 3.47551 3.73738C3.18899 4.22703 3.13508 4.87396 3.02726 6.16782Z"
          stroke="currentColor"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
  CheckIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 12 12" fill="none" {...props}>
      <path d="M10 3L4.5 8.5L2 6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  SendIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M7.00028 7.99986H3.33362M3.27718 8.19419L1.72057 12.844C1.59828 13.2093 1.53713 13.3919 1.58101 13.5044C1.61912 13.6021 1.70096 13.6761 1.80195 13.7043C1.91824 13.7368 2.09388 13.6577 2.44517 13.4997L13.5862 8.48622C13.929 8.33192 14.1005 8.25477 14.1535 8.1476C14.1995 8.05449 14.1995 7.94524 14.1535 7.85212C14.1005 7.74495 13.929 7.6678 13.5862 7.5135L2.44129 2.49834C2.09106 2.34074 1.91595 2.26194 1.79977 2.29426C1.69888 2.32234 1.61704 2.39619 1.57881 2.49369C1.53478 2.60595 1.59527 2.7882 1.71625 3.15271L3.27761 7.85688C3.29839 7.91948 3.30878 7.95079 3.31288 7.9828C3.31652 8.01121 3.31649 8.03997 3.31277 8.06837C3.30859 8.10037 3.29812 8.13164 3.27718 8.19419Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  ArrowLeft: (props: React.SVGProps<SVGSVGElement>) => {
    const { rotate } = props;
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        {...props}
        fill="none"
        style={{ transform: `rotate(${rotate ? rotate : 0}deg)` }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5 15L7.5 10L12.5 5"
          stroke="#A1A1AA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },

  Close: (props: React.SVGProps<SVGSVGElement>) => {
    const { mode } = props;

    return (
      <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14.1673 5.83301L5.83398 14.1663M5.83398 5.83301L14.1673 14.1663"
          stroke={mode === "light" ? "black" : "white"}
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.1673 5.83301L5.83398 14.1663M5.83398 5.83301L14.1673 14.1663"
          stroke={mode === "light" ? "black" : "white"}
          strokeOpacity="0.2"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.1673 5.83301L5.83398 14.1663M5.83398 5.83301L14.1673 14.1663"
          stroke={mode === "light" ? "black" : "white"}
          strokeOpacity="0.2"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },

  Lines: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="94" height="82" viewBox="0 0 94 82" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Lines" clipPath="url(#clip0_3644_55246)">
        <path
          id="Vector"
          d="M10.4277 43.343C23.4275 31.4931 36.9183 20.2056 50.7719 9.34661C51.8371 8.50763 50.3406 7.63578 49.6057 7.44234C48.2966 7.10308 46.7673 7.40051 45.708 8.20973C31.6996 18.914 18.2327 30.3146 5.20018 42.1734C4.17959 43.0986 5.56306 43.9169 6.40209 44.1312C7.65467 44.4437 9.44284 44.2444 10.4277 43.343Z"
          fill="#A855F7"
        />
        <path
          id="Vector_2"
          d="M23.9197 55.2479C30.9178 52.4396 37.9158 49.6314 44.902 46.8052C45.7262 46.475 46.8301 45.5974 45.8007 44.788C44.7713 43.9787 42.9534 44.0946 41.8465 44.523C34.8217 47.3104 27.8117 50.1009 20.7838 52.9032C19.9418 53.2453 18.8022 54.1467 19.8584 54.9769C20.9146 55.8071 22.7771 55.7001 23.9048 55.2449L23.9197 55.2479Z"
          fill="#A855F7"
        />
        <path
          id="Vector_3"
          d="M35.4183 72.7107C50.6401 70.8669 65.8708 69.0558 81.1015 67.1675C81.9405 67.0723 83.9667 66.766 83.8865 65.5431C83.8092 64.3827 81.6967 64.1922 80.9202 64.2844C65.6924 66.0805 50.4707 67.9243 35.234 69.7651C34.3771 69.8722 32.3063 70.1696 32.3955 71.4252C32.4698 72.6004 34.6269 72.7999 35.4362 72.6988L35.4183 72.7107Z"
          fill="#A855F7"
        />
      </g>
      <defs>
        <clipPath id="clip0_3644_55246">
          <rect width="82" height="66.9806" fill="white" transform="translate(13.3667 0.192261) rotate(11.3134)" />
        </clipPath>
      </defs>
    </svg>
  ),
  PlanesIcons: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="82" height="97" viewBox="0 0 82 97" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Plane Illustration" clipPath="url(#clip0_3644_55250)">
        <path
          id="Vector"
          d="M60.7637 36.2227C45.2195 27.4186 29.6753 18.6145 14.1311 9.81047C9.72373 7.31055 5.29664 4.83039 0.918957 2.27118C0.316162 1.92534 -0.177933 1.20402 0.57309 0.739609C1.32412 0.275196 2.6483 0.719847 3.34991 1.10521C19.0127 9.71166 34.4878 18.6837 50.032 27.4878L63.2935 34.9974C63.9259 35.3532 64.4299 36.1239 63.6493 36.5982C62.8686 37.0725 61.4752 36.6278 60.744 36.2128L60.7637 36.2227Z"
          fill="#3DD69E"
        />
        <path
          id="Vector_2"
          d="M3.82411 1.83634C4.09092 22.4978 4.55537 43.1592 5.22734 63.8107C5.4151 69.7097 5.6325 75.6088 5.8499 81.5078C5.90919 83.069 2.0849 82.2983 2.03549 81.0335C1.24494 60.382 0.661907 39.7304 0.276513 19.069C0.167812 13.17 0.0788689 7.26107 -0.000186443 1.36204C-0.0199504 -0.209054 3.80435 0.581436 3.81423 1.83634H3.82411Z"
          fill="#3DD69E"
        />
        <path
          id="Vector_3"
          d="M63.8369 36.1634C47.6108 47.1413 32.867 60.0855 17.9256 72.7037C13.7357 76.2412 9.51609 79.7588 5.24711 83.2074C4.56525 83.7607 3.46836 83.573 2.71733 83.2469C2.34182 83.0888 1.01765 82.2687 1.6995 81.7153C17.056 69.3046 31.6812 55.9849 47.3736 43.9892C51.7612 40.6395 56.2278 37.3985 60.8031 34.3057C61.8309 33.614 65.3587 35.1258 63.8369 36.1535V36.1634Z"
          fill="#3DD69E"
        />
        <path
          id="Vector_4"
          d="M4.08109 1.27326C15.2575 13.6642 26.2363 26.233 37.0175 38.9598C40.0907 42.5862 43.1442 46.2323 46.1879 49.8883C46.7808 50.5998 45.6839 50.9852 45.1503 51.0148C44.2411 51.0642 43.2134 50.6788 42.6304 49.9773C31.9579 37.1516 21.0977 24.484 10.03 11.9943C6.87767 8.43707 3.70558 4.88975 0.523613 1.35231C-0.108829 0.650746 1.05723 0.255502 1.56121 0.225858C2.49998 0.176453 3.45853 0.581579 4.08109 1.26338V1.27326Z"
          fill="#3DD69E"
        />
        <path
          id="Vector_5"
          d="M8.49856 3.79298C15.0404 18.5455 21.2857 33.4462 27.1951 48.4655C28.875 52.7243 30.5253 56.9929 32.1558 61.2714C32.472 62.0916 30.9305 62.1311 30.5055 62.0916C29.7051 62.0026 28.6477 61.6173 28.3315 60.7971C22.5901 45.7087 16.5424 30.7388 10.1686 15.9072C8.36021 11.6979 6.53206 7.50828 4.67426 3.31868C4.31851 2.50843 5.93914 2.45903 6.32454 2.49855C7.1645 2.59736 8.13293 2.98272 8.49856 3.79298Z"
          fill="#3DD69E"
        />
        <path
          id="Vector_6"
          d="M32.5905 60.3721C35.2883 64.3739 38.1836 68.2177 41.0099 72.1306C41.5138 72.8223 40.5849 73.178 40.0316 73.1977C39.1718 73.2274 38.1935 72.8914 37.6401 72.2096C34.6064 68.4548 31.8493 64.453 29.1516 60.4511C28.6674 59.7298 29.5666 59.3839 30.1497 59.3642C30.96 59.3444 32.1063 59.6507 32.5905 60.3721Z"
          fill="#3DD69E"
        />
        <path
          id="Vector_7"
          d="M44.9527 51.3409C44.0534 59.3742 43.3814 67.4768 42.1759 75.4805C41.9881 76.7255 38.4504 75.8362 38.5492 74.5121C39.1619 66.4392 40.3082 58.3861 41.2173 50.3429C41.3557 49.1078 45.1108 49.9378 44.9527 51.3409Z"
          fill="#3DD69E"
        />
        <path
          id="Vector_8"
          d="M36.0294 73.8994C34.3594 72.3678 32.6301 70.9054 30.8414 69.5122C29.0528 68.1189 27.2148 66.9431 25.3471 65.5696C24.7937 65.1546 24.9024 64.5222 25.525 64.3147C26.3155 64.0479 27.2938 64.3147 27.9856 64.7198C30.0311 65.9055 31.9581 67.3877 33.8258 68.8304C35.6935 70.273 37.3931 71.7255 39.0829 73.2769C39.2905 73.4646 39.5474 73.7907 39.4585 74.097C39.3695 74.4033 38.994 74.5614 38.7173 74.6207C37.8576 74.8084 36.6816 74.5021 36.0196 73.8994H36.0294Z"
          fill="#3DD69E"
        />
        <path
          id="Vector_9"
          d="M32.6004 68.1782C31.4245 67.0518 30.2386 65.9352 29.0627 64.7989C28.8749 64.6111 28.6378 64.3345 28.7168 64.038C28.7959 63.7416 29.1418 63.6033 29.3987 63.5539C29.8335 63.4748 30.2979 63.5045 30.713 63.6329C31.128 63.7614 31.5727 63.9195 31.8889 64.2258C33.0846 65.3423 34.2705 66.4688 35.4563 67.5952C35.6539 67.783 35.8911 68.0695 35.812 68.366C35.733 68.6624 35.3772 68.8106 35.1203 68.86C34.6855 68.9391 34.2112 68.9094 33.7862 68.781C33.3613 68.6525 32.9166 68.4845 32.6004 68.1782Z"
          fill="#3DD69E"
        />
        <path
          id="Vector_10"
          d="M37.0768 70.026L37.4326 70.2039C37.8279 70.4015 37.1756 70.0754 37.4919 70.2335L35.3771 71.2513C33.4008 69.0972 31.3453 67.0222 29.2504 64.9768C29.0626 64.789 28.8254 64.5124 28.9045 64.2159C28.9836 63.9195 29.3294 63.7812 29.5864 63.7318C30.3868 63.5835 31.4738 63.8207 32.0865 64.4037C34.2111 66.4095 36.2468 68.5142 38.2132 70.6782C38.3714 70.8561 38.6678 71.1525 38.5591 71.439C38.4702 71.6762 38.2725 71.7948 38.0354 71.8738C37.2646 72.1208 36.3752 71.8738 35.6934 71.4884C35.4266 71.3402 35.1597 71.2118 34.9028 71.0734C34.4186 70.8165 33.8652 70.0359 34.5965 69.7C35.3969 69.3442 36.3555 69.6604 37.0867 70.026H37.0768Z"
          fill="#3DD69E"
        />
        <path
          id="Vector_11"
          d="M30.5745 66.8542C29.8037 65.6191 29.0329 64.384 28.2918 63.1291C28.1534 62.882 28.0942 62.6251 28.2918 62.388C28.4894 62.1508 28.9638 62.0718 29.2602 62.0718C29.7345 62.0718 30.2286 62.1508 30.6634 62.3484C31.0192 62.5065 31.4046 62.7141 31.622 63.05C32.4224 64.2753 33.1833 65.5302 33.9541 66.7752C34.1023 67.0222 34.1518 67.289 33.9541 67.5262C33.7565 67.7633 33.2723 67.8423 32.9758 67.8423C32.4916 67.8423 31.9876 67.7633 31.5528 67.5558C31.1971 67.3977 30.7919 67.1902 30.5745 66.8444V66.8542Z"
          fill="#3DD69E"
        />
        <path
          id="Vector_12"
          d="M31.0981 64.5123C30.5645 65.1644 30.0308 65.8166 29.4774 66.4589C29.3687 66.5676 29.2304 66.6466 29.0723 66.6762C28.8944 66.7454 28.7067 66.7751 28.509 66.7751C28.2719 66.7751 28.0446 66.7553 27.8173 66.7059C27.5702 66.6664 27.3331 66.5972 27.1058 66.4984L26.7006 66.2909C26.4832 66.1624 26.2955 66.0043 26.1472 65.7968L26.0287 65.5399C25.9891 65.3621 26.0287 65.204 26.1571 65.0656C26.671 64.4036 27.2046 63.7514 27.7283 63.1092C27.8469 62.9906 27.9754 62.9214 28.1335 62.8918C28.3114 62.8226 28.509 62.793 28.7067 62.793C28.9438 62.793 29.181 62.8127 29.4083 62.8621C29.6553 62.9017 29.8925 62.9708 30.1296 63.0696L30.5348 63.2771C30.7522 63.4056 30.94 63.5736 31.0981 63.7712L31.2265 64.038C31.2661 64.2257 31.2265 64.3838 31.0981 64.5222V64.5123Z"
          fill="#3DD69E"
        />
        <path
          id="Vector_13"
          d="M77.0592 49.8784L81.6444 54.4632C81.8321 54.6509 82.0693 54.9177 81.9902 55.2142C81.9112 55.4908 81.5653 55.6489 81.3183 55.6885C80.8933 55.7675 80.4388 55.7379 80.0237 55.6094C79.6087 55.481 79.164 55.3327 78.8676 55.0264L74.2725 50.4416C74.0847 50.2539 73.8475 49.9871 73.9266 49.6906C74.0057 49.414 74.3515 49.2559 74.5986 49.2163C75.0235 49.1373 75.4781 49.1669 75.8931 49.2954C76.3081 49.4238 76.7528 49.5721 77.0493 49.8784H77.0592Z"
          fill="#3DD69E"
        />
        <path
          id="Vector_14"
          d="M62.4933 57.971L70.8533 66.3403C71.0411 66.5281 71.2783 66.7948 71.1992 67.1012C71.1202 67.3778 70.7743 67.5359 70.5174 67.5853C69.7367 67.7335 68.62 67.5063 68.037 66.9233L59.667 58.554C59.4793 58.3662 59.2421 58.0896 59.3212 57.7931C59.4002 57.5066 59.7461 57.3584 60.003 57.309C60.7837 57.1608 61.9102 57.388 62.4933 57.9809V57.971Z"
          fill="#3DD69E"
        />
        <path
          id="Vector_15"
          d="M33.0845 79.0277C35.6933 81.9031 38.3021 84.7884 40.9011 87.6638C41.0888 87.8614 41.3359 88.1183 41.2469 88.4247C41.1679 88.7112 40.8121 88.8594 40.5651 88.9088C39.8141 89.0472 38.6183 88.8397 38.065 88.2369C35.4463 85.3615 32.8374 82.4762 30.2286 79.6008C30.0409 79.3933 29.7938 79.1463 29.8729 78.8301C29.9519 78.5435 30.3077 78.3854 30.5646 78.336C31.3255 78.1977 32.5311 78.4052 33.0845 79.008V79.0277Z"
          fill="#3DD69E"
        />
        <path
          id="Vector_16"
          d="M8.00442 87.9208C10.6132 90.4405 13.2122 92.9602 15.821 95.4799C16.0088 95.6676 16.2558 95.9443 16.1767 96.2407C16.0977 96.5371 15.7419 96.6854 15.485 96.7249C14.6846 96.8731 13.5877 96.6359 12.975 96.053C10.3563 93.5333 7.74749 91.0136 5.13867 88.4939C4.94103 88.3062 4.70386 88.0196 4.78292 87.7232C4.86197 87.4267 5.21772 87.2785 5.47465 87.2291C6.28496 87.0809 7.39174 87.3181 8.00442 87.9109V87.9208Z"
          fill="#3DD69E"
        />
      </g>
      <defs>
        <clipPath id="clip0_3644_55250">
          <rect width="82" height="96.5484" fill="white" transform="matrix(-1 0 0 1 82 0.22583)" />
        </clipPath>
      </defs>
    </svg>
  ),
  UserPlusIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="users-plus">
        <path
          id="Icon"
          d="M15.8333 17.5V12.5M13.3333 15H18.3333M9.99996 12.5H6.66663C5.11349 12.5 4.33692 12.5 3.72435 12.7537C2.90759 13.092 2.25867 13.741 1.92036 14.5577C1.66663 15.1703 1.66663 15.9469 1.66663 17.5M12.9166 2.7423C14.1382 3.23679 15 4.43443 15 5.83333C15 7.23224 14.1382 8.42988 12.9166 8.92437M11.25 5.83333C11.25 7.67428 9.75757 9.16667 7.91663 9.16667C6.07568 9.16667 4.58329 7.67428 4.58329 5.83333C4.58329 3.99238 6.07568 2.5 7.91663 2.5C9.75757 2.5 11.25 3.99238 11.25 5.83333Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),

  PlayIcon: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_3671_129703)">
        <path
          d="M8 14.6673C11.6819 14.6673 14.6667 11.6826 14.6667 8.00065C14.6667 4.31875 11.6819 1.33398 8 1.33398C4.3181 1.33398 1.33333 4.31875 1.33333 8.00065C1.33333 11.6826 4.3181 14.6673 8 14.6673Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 14.6673C11.6819 14.6673 14.6667 11.6826 14.6667 8.00065C14.6667 4.31875 11.6819 1.33398 8 1.33398C4.3181 1.33398 1.33333 4.31875 1.33333 8.00065C1.33333 11.6826 4.3181 14.6673 8 14.6673Z"
          stroke="currentColor"
          strokeOpacity="0.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 14.6673C11.6819 14.6673 14.6667 11.6826 14.6667 8.00065C14.6667 4.31875 11.6819 1.33398 8 1.33398C4.3181 1.33398 1.33333 4.31875 1.33333 8.00065C1.33333 11.6826 4.3181 14.6673 8 14.6673Z"
          stroke="currentColor"
          strokeOpacity="0.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.33333 5.97754C6.33333 5.65935 6.33333 5.50025 6.39982 5.41144C6.45777 5.33403 6.54647 5.28561 6.64291 5.27872C6.75358 5.27082 6.88741 5.35685 7.15507 5.52891L10.3021 7.55202C10.5344 7.70133 10.6505 7.77598 10.6906 7.87091C10.7257 7.95385 10.7257 8.04745 10.6906 8.13039C10.6505 8.22532 10.5344 8.29997 10.3021 8.44928L7.15507 10.4724C6.88741 10.6445 6.75358 10.7305 6.64291 10.7226C6.54647 10.7157 6.45777 10.6673 6.39982 10.5899C6.33333 10.501 6.33333 10.342 6.33333 10.0238V5.97754Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.33333 5.97754C6.33333 5.65935 6.33333 5.50025 6.39982 5.41144C6.45777 5.33403 6.54647 5.28561 6.64291 5.27872C6.75358 5.27082 6.88741 5.35685 7.15507 5.52891L10.3021 7.55202C10.5344 7.70133 10.6505 7.77598 10.6906 7.87091C10.7257 7.95385 10.7257 8.04745 10.6906 8.13039C10.6505 8.22532 10.5344 8.29997 10.3021 8.44928L7.15507 10.4724C6.88741 10.6445 6.75358 10.7305 6.64291 10.7226C6.54647 10.7157 6.45777 10.6673 6.39982 10.5899C6.33333 10.501 6.33333 10.342 6.33333 10.0238V5.97754Z"
          stroke="currentColor"
          strokeOpacity="0.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.33333 5.97754C6.33333 5.65935 6.33333 5.50025 6.39982 5.41144C6.45777 5.33403 6.54647 5.28561 6.64291 5.27872C6.75358 5.27082 6.88741 5.35685 7.15507 5.52891L10.3021 7.55202C10.5344 7.70133 10.6505 7.77598 10.6906 7.87091C10.7257 7.95385 10.7257 8.04745 10.6906 8.13039C10.6505 8.22532 10.5344 8.29997 10.3021 8.44928L7.15507 10.4724C6.88741 10.6445 6.75358 10.7305 6.64291 10.7226C6.54647 10.7157 6.45777 10.6673 6.39982 10.5899C6.33333 10.501 6.33333 10.342 6.33333 10.0238V5.97754Z"
          stroke="currentColor"
          strokeOpacity="0.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3671_129703">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
};

export const AnouncementIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} viewBox="0 0 12 12" fill="none">
      <path
        d="M11 3.99996V5.99996M5.125 2.74996H3.4C2.55992 2.74996 2.13988 2.74996 1.81901 2.91345C1.53677 3.05726 1.3073 3.28673 1.16349 3.56897C0.999999 3.88984 0.999999 4.30988 1 5.14996L1 5.74996C1 6.2159 1 6.44887 1.07612 6.63264C1.17762 6.87767 1.37229 7.07234 1.61732 7.17384C1.80109 7.24996 2.03406 7.24996 2.5 7.24996V9.37496C2.5 9.49104 2.5 9.54908 2.50482 9.59797C2.55158 10.0728 2.92721 10.4484 3.40198 10.4951C3.45087 10.5 3.50892 10.5 3.625 10.5C3.74109 10.5 3.79913 10.5 3.84802 10.4951C4.3228 10.4484 4.69842 10.0728 4.74519 9.59797C4.75 9.54908 4.75 9.49104 4.75 9.37496V7.24996H5.125C6.00821 7.24996 7.08862 7.7234 7.92215 8.17778C8.40841 8.44286 8.65155 8.57539 8.81079 8.55589C8.95845 8.53781 9.0701 8.47151 9.15666 8.35051C9.25 8.22003 9.25 7.95896 9.25 7.43681V2.5631C9.25 2.04095 9.25 1.77988 9.15666 1.6494C9.0701 1.52841 8.95845 1.46211 8.81079 1.44402C8.65155 1.42452 8.40841 1.55706 7.92215 1.82213C7.08862 2.27651 6.00821 2.74996 5.125 2.74996Z"
        stroke="#A1A1AA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DiamondIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} viewBox="0 0 12 12" fill="none">
    <path
      d="M1.24977 4.5H10.7498M4.99977 1.5L3.99977 4.5L5.99977 10.25L7.99977 4.5L6.99977 1.5M6.30706 10.1313L10.7864 4.75607C10.8623 4.66498 10.9002 4.61943 10.9148 4.56858C10.9275 4.52375 10.9275 4.47624 10.9148 4.43142C10.9002 4.38057 10.8623 4.33502 10.7864 4.24393L8.61971 1.64393C8.57562 1.59102 8.55358 1.56457 8.52655 1.54555C8.50261 1.5287 8.4759 1.51619 8.44763 1.50858C8.41572 1.5 8.38128 1.5 8.31242 1.5H3.68712C3.61825 1.5 3.58382 1.5 3.55191 1.50858C3.52364 1.51619 3.49692 1.5287 3.47298 1.54555C3.44596 1.56457 3.42392 1.59102 3.37983 1.64393L1.21316 4.24393C1.13725 4.33502 1.09929 4.38057 1.08479 4.43142C1.072 4.47624 1.072 4.52375 1.08479 4.56858C1.09929 4.61943 1.13725 4.66498 1.21316 4.75607L5.69248 10.1313C5.79801 10.2579 5.85077 10.3212 5.91394 10.3443C5.96937 10.3646 6.03017 10.3646 6.08559 10.3443C6.14876 10.3212 6.20153 10.2579 6.30706 10.1313Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TrashIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none">
      <path
        d="M13.3333 4.99996V4.33329C13.3333 3.39987 13.3333 2.93316 13.1517 2.57664C12.9919 2.26304 12.7369 2.00807 12.4233 1.84828C12.0668 1.66663 11.6001 1.66663 10.6667 1.66663H9.33333C8.39991 1.66663 7.9332 1.66663 7.57668 1.84828C7.26308 2.00807 7.00811 2.26304 6.84832 2.57664C6.66667 2.93316 6.66667 3.39987 6.66667 4.33329V4.99996M8.33333 9.58329V13.75M11.6667 9.58329V13.75M2.5 4.99996H17.5M15.8333 4.99996V14.3333C15.8333 15.7334 15.8333 16.4335 15.5608 16.9683C15.3212 17.4387 14.9387 17.8211 14.4683 18.0608C13.9335 18.3333 13.2335 18.3333 11.8333 18.3333H8.16667C6.76654 18.3333 6.06647 18.3333 5.53169 18.0608C5.06129 17.8211 4.67883 17.4387 4.43915 16.9683C4.16667 16.4335 4.16667 15.7334 4.16667 14.3333V4.99996"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ChevronUpDoubleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none">
    <path
      d="M14.1667 15L10 10.8333L5.83337 15M14.1667 9.16667L10 5L5.83337 9.16667"
      stroke="#A855F7"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AlertCircleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none">
    <g clipPath="url(#clip0_961_17518)">
      <path
        d="M10 6.66675V10.0001M10 13.3334H10.0084M18.3334 10.0001C18.3334 14.6025 14.6024 18.3334 10 18.3334C5.39765 18.3334 1.66669 14.6025 1.66669 10.0001C1.66669 5.39771 5.39765 1.66675 10 1.66675C14.6024 1.66675 18.3334 5.39771 18.3334 10.0001Z"
        stroke="#EF5656"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_961_17518">
        <rect width={20} height={20} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const UserBadgeIcon = () => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x={1} y={1} width={22} height={22} rx={11} fill="#A855F7" />
    <rect x={1} y={1} width={22} height={22} rx={11} stroke="#D4D4D8" strokeWidth={2} />
    <path
      d="M9.98334 13.361L9.5 17L11.7942 15.6235C11.869 15.5786 11.9064 15.5561 11.9464 15.5474C11.9817 15.5396 12.0183 15.5396 12.0536 15.5474C12.0936 15.5561 12.131 15.5786 12.2058 15.6235L14.5 17L14.0171 13.3606M15.5 10.5C15.5 12.433 13.933 14 12 14C10.067 14 8.5 12.433 8.5 10.5C8.5 8.567 10.067 7 12 7C13.933 7 15.5 8.567 15.5 10.5Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserTreeIcon = () => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x={1} y={1} width={22} height={22} rx={11} fill="#D4D4D8" />
    <rect x={1} y={1} width={22} height={22} rx={11} stroke="#D4D4D8" strokeWidth={2} />
    <path
      d="M14.5 16H14.4C13.5599 16 13.1399 16 12.819 15.8365C12.5368 15.6927 12.3073 15.4632 12.1635 15.181C12 14.8601 12 14.4401 12 13.6V10.4C12 9.55992 12 9.13988 12.1635 8.81901C12.3073 8.53677 12.5368 8.3073 12.819 8.16349C13.1399 8 13.5599 8 14.4 8H14.5M14.5 16C14.5 16.5523 14.9477 17 15.5 17C16.0523 17 16.5 16.5523 16.5 16C16.5 15.4477 16.0523 15 15.5 15C14.9477 15 14.5 15.4477 14.5 16ZM14.5 8C14.5 8.55228 14.9477 9 15.5 9C16.0523 9 16.5 8.55228 16.5 8C16.5 7.44772 16.0523 7 15.5 7C14.9477 7 14.5 7.44772 14.5 8ZM9.5 12L14.5 12M9.5 12C9.5 12.5523 9.05228 13 8.5 13C7.94772 13 7.5 12.5523 7.5 12C7.5 11.4477 7.94772 11 8.5 11C9.05228 11 9.5 11.4477 9.5 12ZM14.5 12C14.5 12.5523 14.9477 13 15.5 13C16.0523 13 16.5 12.5523 16.5 12C16.5 11.4477 16.0523 11 15.5 11C14.9477 11 14.5 11.4477 14.5 12Z"
      stroke="#52525B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlayIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#clip0_3671_129703)">
      <path
        d="M8 14.6673C11.6819 14.6673 14.6667 11.6826 14.6667 8.00065C14.6667 4.31875 11.6819 1.33398 8 1.33398C4.3181 1.33398 1.33333 4.31875 1.33333 8.00065C1.33333 11.6826 4.3181 14.6673 8 14.6673Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 14.6673C11.6819 14.6673 14.6667 11.6826 14.6667 8.00065C14.6667 4.31875 11.6819 1.33398 8 1.33398C4.3181 1.33398 1.33333 4.31875 1.33333 8.00065C1.33333 11.6826 4.3181 14.6673 8 14.6673Z"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 14.6673C11.6819 14.6673 14.6667 11.6826 14.6667 8.00065C14.6667 4.31875 11.6819 1.33398 8 1.33398C4.3181 1.33398 1.33333 4.31875 1.33333 8.00065C1.33333 11.6826 4.3181 14.6673 8 14.6673Z"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.33333 5.97754C6.33333 5.65935 6.33333 5.50025 6.39982 5.41144C6.45777 5.33403 6.54647 5.28561 6.64291 5.27872C6.75358 5.27082 6.88741 5.35685 7.15507 5.52891L10.3021 7.55202C10.5344 7.70133 10.6505 7.77598 10.6906 7.87091C10.7257 7.95385 10.7257 8.04745 10.6906 8.13039C10.6505 8.22532 10.5344 8.29997 10.3021 8.44928L7.15507 10.4724C6.88741 10.6445 6.75358 10.7305 6.64291 10.7226C6.54647 10.7157 6.45777 10.6673 6.39982 10.5899C6.33333 10.501 6.33333 10.342 6.33333 10.0238V5.97754Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.33333 5.97754C6.33333 5.65935 6.33333 5.50025 6.39982 5.41144C6.45777 5.33403 6.54647 5.28561 6.64291 5.27872C6.75358 5.27082 6.88741 5.35685 7.15507 5.52891L10.3021 7.55202C10.5344 7.70133 10.6505 7.77598 10.6906 7.87091C10.7257 7.95385 10.7257 8.04745 10.6906 8.13039C10.6505 8.22532 10.5344 8.29997 10.3021 8.44928L7.15507 10.4724C6.88741 10.6445 6.75358 10.7305 6.64291 10.7226C6.54647 10.7157 6.45777 10.6673 6.39982 10.5899C6.33333 10.501 6.33333 10.342 6.33333 10.0238V5.97754Z"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.33333 5.97754C6.33333 5.65935 6.33333 5.50025 6.39982 5.41144C6.45777 5.33403 6.54647 5.28561 6.64291 5.27872C6.75358 5.27082 6.88741 5.35685 7.15507 5.52891L10.3021 7.55202C10.5344 7.70133 10.6505 7.77598 10.6906 7.87091C10.7257 7.95385 10.7257 8.04745 10.6906 8.13039C10.6505 8.22532 10.5344 8.29997 10.3021 8.44928L7.15507 10.4724C6.88741 10.6445 6.75358 10.7305 6.64291 10.7226C6.54647 10.7157 6.45777 10.6673 6.39982 10.5899C6.33333 10.501 6.33333 10.342 6.33333 10.0238V5.97754Z"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3671_129703">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CampaignsIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const { mode } = props;
  return (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.99967 2.99967C8.45991 2.99967 8.83301 2.62658 8.83301 2.16634C8.83301 1.7061 8.45991 1.33301 7.99967 1.33301C7.53944 1.33301 7.16634 1.7061 7.16634 2.16634C7.16634 2.62658 7.53944 2.99967 7.99967 2.99967Z"
        stroke={mode === "light" ? "black" : "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99967 2.99967C8.45991 2.99967 8.83301 2.62658 8.83301 2.16634C8.83301 1.7061 8.45991 1.33301 7.99967 1.33301C7.53944 1.33301 7.16634 1.7061 7.16634 2.16634C7.16634 2.62658 7.53944 2.99967 7.99967 2.99967Z"
        stroke={mode === "light" ? "black" : "white"}
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99967 2.99967C8.45991 2.99967 8.83301 2.62658 8.83301 2.16634C8.83301 1.7061 8.45991 1.33301 7.99967 1.33301C7.53944 1.33301 7.16634 1.7061 7.16634 2.16634C7.16634 2.62658 7.53944 2.99967 7.99967 2.99967Z"
        stroke={mode === "light" ? "black" : "white"}
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99967 8.83301C8.45991 8.83301 8.83301 8.45991 8.83301 7.99967C8.83301 7.53944 8.45991 7.16634 7.99967 7.16634C7.53944 7.16634 7.16634 7.53944 7.16634 7.99967C7.16634 8.45991 7.53944 8.83301 7.99967 8.83301Z"
        stroke={mode === "light" ? "black" : "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99967 8.83301C8.45991 8.83301 8.83301 8.45991 8.83301 7.99967C8.83301 7.53944 8.45991 7.16634 7.99967 7.16634C7.53944 7.16634 7.16634 7.53944 7.16634 7.99967C7.16634 8.45991 7.53944 8.83301 7.99967 8.83301Z"
        stroke={mode === "light" ? "black" : "white"}
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99967 8.83301C8.45991 8.83301 8.83301 8.45991 8.83301 7.99967C8.83301 7.53944 8.45991 7.16634 7.99967 7.16634C7.53944 7.16634 7.16634 7.53944 7.16634 7.99967C7.16634 8.45991 7.53944 8.83301 7.99967 8.83301Z"
        stroke={mode === "light" ? "black" : "white"}
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99967 14.6663C8.45991 14.6663 8.83301 14.2932 8.83301 13.833C8.83301 13.3728 8.45991 12.9997 7.99967 12.9997C7.53944 12.9997 7.16634 13.3728 7.16634 13.833C7.16634 14.2932 7.53944 14.6663 7.99967 14.6663Z"
        stroke={mode === "light" ? "black" : "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99967 14.6663C8.45991 14.6663 8.83301 14.2932 8.83301 13.833C8.83301 13.3728 8.45991 12.9997 7.99967 12.9997C7.53944 12.9997 7.16634 13.3728 7.16634 13.833C7.16634 14.2932 7.53944 14.6663 7.99967 14.6663Z"
        stroke={mode === "light" ? "black" : "white"}
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99967 14.6663C8.45991 14.6663 8.83301 14.2932 8.83301 13.833C8.83301 13.3728 8.45991 12.9997 7.99967 12.9997C7.53944 12.9997 7.16634 13.3728 7.16634 13.833C7.16634 14.2932 7.53944 14.6663 7.99967 14.6663Z"
        stroke={mode === "light" ? "black" : "white"}
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.833 2.99967C14.2932 2.99967 14.6663 2.62658 14.6663 2.16634C14.6663 1.7061 14.2932 1.33301 13.833 1.33301C13.3728 1.33301 12.9997 1.7061 12.9997 2.16634C12.9997 2.62658 13.3728 2.99967 13.833 2.99967Z"
        stroke={mode === "light" ? "black" : "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.833 2.99967C14.2932 2.99967 14.6663 2.62658 14.6663 2.16634C14.6663 1.7061 14.2932 1.33301 13.833 1.33301C13.3728 1.33301 12.9997 1.7061 12.9997 2.16634C12.9997 2.62658 13.3728 2.99967 13.833 2.99967Z"
        stroke={mode === "light" ? "black" : "white"}
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.833 2.99967C14.2932 2.99967 14.6663 2.62658 14.6663 2.16634C14.6663 1.7061 14.2932 1.33301 13.833 1.33301C13.3728 1.33301 12.9997 1.7061 12.9997 2.16634C12.9997 2.62658 13.3728 2.99967 13.833 2.99967Z"
        stroke={mode === "light" ? "black" : "white"}
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.833 8.83301C14.2932 8.83301 14.6663 8.45991 14.6663 7.99967C14.6663 7.53944 14.2932 7.16634 13.833 7.16634C13.3728 7.16634 12.9997 7.53944 12.9997 7.99967C12.9997 8.45991 13.3728 8.83301 13.833 8.83301Z"
        stroke={mode === "light" ? "black" : "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.833 8.83301C14.2932 8.83301 14.6663 8.45991 14.6663 7.99967C14.6663 7.53944 14.2932 7.16634 13.833 7.16634C13.3728 7.16634 12.9997 7.53944 12.9997 7.99967C12.9997 8.45991 13.3728 8.83301 13.833 8.83301Z"
        stroke={mode === "light" ? "black" : "white"}
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.833 8.83301C14.2932 8.83301 14.6663 8.45991 14.6663 7.99967C14.6663 7.53944 14.2932 7.16634 13.833 7.16634C13.3728 7.16634 12.9997 7.53944 12.9997 7.99967C12.9997 8.45991 13.3728 8.83301 13.833 8.83301Z"
        stroke={mode === "light" ? "black" : "white"}
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.833 14.6663C14.2932 14.6663 14.6663 14.2932 14.6663 13.833C14.6663 13.3728 14.2932 12.9997 13.833 12.9997C13.3728 12.9997 12.9997 13.3728 12.9997 13.833C12.9997 14.2932 13.3728 14.6663 13.833 14.6663Z"
        stroke={mode === "light" ? "black" : "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.833 14.6663C14.2932 14.6663 14.6663 14.2932 14.6663 13.833C14.6663 13.3728 14.2932 12.9997 13.833 12.9997C13.3728 12.9997 12.9997 13.3728 12.9997 13.833C12.9997 14.2932 13.3728 14.6663 13.833 14.6663Z"
        stroke={mode === "light" ? "black" : "white"}
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.833 14.6663C14.2932 14.6663 14.6663 14.2932 14.6663 13.833C14.6663 13.3728 14.2932 12.9997 13.833 12.9997C13.3728 12.9997 12.9997 13.3728 12.9997 13.833C12.9997 14.2932 13.3728 14.6663 13.833 14.6663Z"
        stroke={mode === "light" ? "black" : "white"}
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.16634 2.99967C2.62658 2.99967 2.99967 2.62658 2.99967 2.16634C2.99967 1.7061 2.62658 1.33301 2.16634 1.33301C1.7061 1.33301 1.33301 1.7061 1.33301 2.16634C1.33301 2.62658 1.7061 2.99967 2.16634 2.99967Z"
        stroke={mode === "light" ? "black" : "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.16634 2.99967C2.62658 2.99967 2.99967 2.62658 2.99967 2.16634C2.99967 1.7061 2.62658 1.33301 2.16634 1.33301C1.7061 1.33301 1.33301 1.7061 1.33301 2.16634C1.33301 2.62658 1.7061 2.99967 2.16634 2.99967Z"
        stroke={mode === "light" ? "black" : "white"}
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.16634 2.99967C2.62658 2.99967 2.99967 2.62658 2.99967 2.16634C2.99967 1.7061 2.62658 1.33301 2.16634 1.33301C1.7061 1.33301 1.33301 1.7061 1.33301 2.16634C1.33301 2.62658 1.7061 2.99967 2.16634 2.99967Z"
        stroke={mode === "light" ? "black" : "white"}
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.16634 8.83301C2.62658 8.83301 2.99967 8.45991 2.99967 7.99967C2.99967 7.53944 2.62658 7.16634 2.16634 7.16634C1.7061 7.16634 1.33301 7.53944 1.33301 7.99967C1.33301 8.45991 1.7061 8.83301 2.16634 8.83301Z"
        stroke={mode === "light" ? "black" : "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.16634 8.83301C2.62658 8.83301 2.99967 8.45991 2.99967 7.99967C2.99967 7.53944 2.62658 7.16634 2.16634 7.16634C1.7061 7.16634 1.33301 7.53944 1.33301 7.99967C1.33301 8.45991 1.7061 8.83301 2.16634 8.83301Z"
        stroke={mode === "light" ? "black" : "white"}
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.16634 8.83301C2.62658 8.83301 2.99967 8.45991 2.99967 7.99967C2.99967 7.53944 2.62658 7.16634 2.16634 7.16634C1.7061 7.16634 1.33301 7.53944 1.33301 7.99967C1.33301 8.45991 1.7061 8.83301 2.16634 8.83301Z"
        stroke={mode === "light" ? "black" : "white"}
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.16634 14.6663C2.62658 14.6663 2.99967 14.2932 2.99967 13.833C2.99967 13.3728 2.62658 12.9997 2.16634 12.9997C1.7061 12.9997 1.33301 13.3728 1.33301 13.833C1.33301 14.2932 1.7061 14.6663 2.16634 14.6663Z"
        stroke={mode === "light" ? "black" : "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.16634 14.6663C2.62658 14.6663 2.99967 14.2932 2.99967 13.833C2.99967 13.3728 2.62658 12.9997 2.16634 12.9997C1.7061 12.9997 1.33301 13.3728 1.33301 13.833C1.33301 14.2932 1.7061 14.6663 2.16634 14.6663Z"
        stroke={mode === "light" ? "black" : "white"}
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.16634 14.6663C2.62658 14.6663 2.99967 14.2932 2.99967 13.833C2.99967 13.3728 2.62658 12.9997 2.16634 12.9997C1.7061 12.9997 1.33301 13.3728 1.33301 13.833C1.33301 14.2932 1.7061 14.6663 2.16634 14.6663Z"
        stroke={mode === "light" ? "black" : "white"}
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SuccessRegistrationIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none">
    <path
      d="M16.6663 5L7.49967 14.1667L3.33301 10"
      stroke="#09090B"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.6663 5L7.49967 14.1667L3.33301 10"
      stroke="black"
      strokeOpacity="0.2"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.6663 5L7.49967 14.1667L3.33301 10"
      stroke="black"
      strokeOpacity="0.2"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LogoutIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const { mode } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" {...props} fill="none">
      <path
        d="M10.6667 11.3332L14 7.99988M14 7.99988L10.6667 4.66655M14 7.99988H6M8 11.3332C8 11.5303 8 11.6288 7.99268 11.7141C7.91655 12.6012 7.26324 13.3311 6.39002 13.5047C6.30602 13.5214 6.20801 13.5323 6.01223 13.5541L5.3313 13.6297C4.30832 13.7434 3.7968 13.8002 3.39044 13.6702C2.84862 13.4968 2.40628 13.1009 2.17412 12.5815C2 12.192 2 11.6774 2 10.6481V5.35168C2 4.32239 2 3.80774 2.17412 3.41822C2.40628 2.89887 2.84862 2.50295 3.39044 2.32956C3.79681 2.19952 4.3083 2.25636 5.33129 2.37002L6.01223 2.44568C6.20808 2.46744 6.306 2.47832 6.39002 2.49503C7.26324 2.66865 7.91655 3.39857 7.99268 4.28562C8 4.37097 8 4.46949 8 4.66655"
        stroke={mode === "dark" ? "white" : "black"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6667 11.3332L14 7.99988M14 7.99988L10.6667 4.66655M14 7.99988H6M8 11.3332C8 11.5303 8 11.6288 7.99268 11.7141C7.91655 12.6012 7.26324 13.3311 6.39002 13.5047C6.30602 13.5214 6.20801 13.5323 6.01223 13.5541L5.3313 13.6297C4.30832 13.7434 3.7968 13.8002 3.39044 13.6702C2.84862 13.4968 2.40628 13.1009 2.17412 12.5815C2 12.192 2 11.6774 2 10.6481V5.35168C2 4.32239 2 3.80774 2.17412 3.41822C2.40628 2.89887 2.84862 2.50295 3.39044 2.32956C3.79681 2.19952 4.3083 2.25636 5.33129 2.37002L6.01223 2.44568C6.20808 2.46744 6.306 2.47832 6.39002 2.49503C7.26324 2.66865 7.91655 3.39857 7.99268 4.28562C8 4.37097 8 4.46949 8 4.66655"
        stroke={mode === "dark" ? "white" : "black"}
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6667 11.3332L14 7.99988M14 7.99988L10.6667 4.66655M14 7.99988H6M8 11.3332C8 11.5303 8 11.6288 7.99268 11.7141C7.91655 12.6012 7.26324 13.3311 6.39002 13.5047C6.30602 13.5214 6.20801 13.5323 6.01223 13.5541L5.3313 13.6297C4.30832 13.7434 3.7968 13.8002 3.39044 13.6702C2.84862 13.4968 2.40628 13.1009 2.17412 12.5815C2 12.192 2 11.6774 2 10.6481V5.35168C2 4.32239 2 3.80774 2.17412 3.41822C2.40628 2.89887 2.84862 2.50295 3.39044 2.32956C3.79681 2.19952 4.3083 2.25636 5.33129 2.37002L6.01223 2.44568C6.20808 2.46744 6.306 2.47832 6.39002 2.49503C7.26324 2.66865 7.91655 3.39857 7.99268 4.28562C8 4.37097 8 4.46949 8 4.66655"
        stroke={mode === "dark" ? "white" : "black"}
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UserAccountIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const { mode } = props;
  return (
    <svg width={22} height={22} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.3163 18.4384C4.92462 17.0052 6.34492 16 8 16H14C15.6551 16 17.0754 17.0052 17.6837 18.4384M15 8.5C15 10.7091 13.2091 12.5 11 12.5C8.79086 12.5 7 10.7091 7 8.5C7 6.29086 8.79086 4.5 11 4.5C13.2091 4.5 15 6.29086 15 8.5ZM21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
        stroke={mode === "dark" ? "white" : "black"}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.3163 18.4384C4.92462 17.0052 6.34492 16 8 16H14C15.6551 16 17.0754 17.0052 17.6837 18.4384M15 8.5C15 10.7091 13.2091 12.5 11 12.5C8.79086 12.5 7 10.7091 7 8.5C7 6.29086 8.79086 4.5 11 4.5C13.2091 4.5 15 6.29086 15 8.5ZM21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
        stroke={mode === "dark" ? "white" : "black"}
        strokeOpacity="0.2"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.3163 18.4384C4.92462 17.0052 6.34492 16 8 16H14C15.6551 16 17.0754 17.0052 17.6837 18.4384M15 8.5C15 10.7091 13.2091 12.5 11 12.5C8.79086 12.5 7 10.7091 7 8.5C7 6.29086 8.79086 4.5 11 4.5C13.2091 4.5 15 6.29086 15 8.5ZM21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
        stroke={mode === "dark" ? "white" : "black"}
        strokeOpacity="0.2"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BusinessAccountIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const { mode } = props;
  return (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 19V13.6C13 13.0399 13 12.7599 12.891 12.546C12.7951 12.3578 12.6422 12.2049 12.454 12.109C12.2401 12 11.9601 12 11.4 12H8.6C8.03995 12 7.75992 12 7.54601 12.109C7.35785 12.2049 7.20487 12.3578 7.10899 12.546C7 12.7599 7 13.0399 7 13.6V19M17 19V4.2C17 3.0799 17 2.51984 16.782 2.09202C16.5903 1.71569 16.2843 1.40973 15.908 1.21799C15.4802 1 14.9201 1 13.8 1H6.2C5.07989 1 4.51984 1 4.09202 1.21799C3.71569 1.40973 3.40973 1.71569 3.21799 2.09202C3 2.51984 3 3.0799 3 4.2V19M19 19H1M7.5 6H7.51M12.5 6H12.51M8 6C8 6.27614 7.77614 6.5 7.5 6.5C7.22386 6.5 7 6.27614 7 6C7 5.72386 7.22386 5.5 7.5 5.5C7.77614 5.5 8 5.72386 8 6ZM13 6C13 6.27614 12.7761 6.5 12.5 6.5C12.2239 6.5 12 6.27614 12 6C12 5.72386 12.2239 5.5 12.5 5.5C12.7761 5.5 13 5.72386 13 6Z"
        stroke={mode === "dark" ? "white" : "black"}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 19V13.6C13 13.0399 13 12.7599 12.891 12.546C12.7951 12.3578 12.6422 12.2049 12.454 12.109C12.2401 12 11.9601 12 11.4 12H8.6C8.03995 12 7.75992 12 7.54601 12.109C7.35785 12.2049 7.20487 12.3578 7.10899 12.546C7 12.7599 7 13.0399 7 13.6V19M17 19V4.2C17 3.0799 17 2.51984 16.782 2.09202C16.5903 1.71569 16.2843 1.40973 15.908 1.21799C15.4802 1 14.9201 1 13.8 1H6.2C5.07989 1 4.51984 1 4.09202 1.21799C3.71569 1.40973 3.40973 1.71569 3.21799 2.09202C3 2.51984 3 3.0799 3 4.2V19M19 19H1M7.5 6H7.51M12.5 6H12.51M8 6C8 6.27614 7.77614 6.5 7.5 6.5C7.22386 6.5 7 6.27614 7 6C7 5.72386 7.22386 5.5 7.5 5.5C7.77614 5.5 8 5.72386 8 6ZM13 6C13 6.27614 12.7761 6.5 12.5 6.5C12.2239 6.5 12 6.27614 12 6C12 5.72386 12.2239 5.5 12.5 5.5C12.7761 5.5 13 5.72386 13 6Z"
        stroke={mode === "dark" ? "white" : "black"}
        strokeOpacity="0.2"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 19V13.6C13 13.0399 13 12.7599 12.891 12.546C12.7951 12.3578 12.6422 12.2049 12.454 12.109C12.2401 12 11.9601 12 11.4 12H8.6C8.03995 12 7.75992 12 7.54601 12.109C7.35785 12.2049 7.20487 12.3578 7.10899 12.546C7 12.7599 7 13.0399 7 13.6V19M17 19V4.2C17 3.0799 17 2.51984 16.782 2.09202C16.5903 1.71569 16.2843 1.40973 15.908 1.21799C15.4802 1 14.9201 1 13.8 1H6.2C5.07989 1 4.51984 1 4.09202 1.21799C3.71569 1.40973 3.40973 1.71569 3.21799 2.09202C3 2.51984 3 3.0799 3 4.2V19M19 19H1M7.5 6H7.51M12.5 6H12.51M8 6C8 6.27614 7.77614 6.5 7.5 6.5C7.22386 6.5 7 6.27614 7 6C7 5.72386 7.22386 5.5 7.5 5.5C7.77614 5.5 8 5.72386 8 6ZM13 6C13 6.27614 12.7761 6.5 12.5 6.5C12.2239 6.5 12 6.27614 12 6C12 5.72386 12.2239 5.5 12.5 5.5C12.7761 5.5 13 5.72386 13 6Z"
        stroke={mode === "dark" ? "white" : "black"}
        strokeOpacity="0.2"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NoSurveysIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width={48} height={48} rx={24} fill="white" />
      <path
        d="M29.417 27.3333C31.0278 27.3333 32.3337 24.9082 32.3337 21.9167C32.3337 18.9251 31.0278 16.5 29.417 16.5M29.417 27.3333C27.8062 27.3333 26.5003 24.9082 26.5003 21.9167C26.5003 18.9251 27.8062 16.5 29.417 16.5M29.417 27.3333L18.5366 25.3551C17.7637 25.2146 17.3772 25.1443 17.0648 24.9908C16.4291 24.6785 15.9556 24.1113 15.7621 23.4299C15.667 23.095 15.667 22.7022 15.667 21.9167C15.667 21.1311 15.667 20.7383 15.7621 20.4034C15.9556 19.7221 16.4291 19.1548 17.0648 18.8425C17.3772 18.689 17.7637 18.6188 18.5366 18.4783L29.417 16.5M18.167 25.6667L18.4952 30.2617C18.5264 30.698 18.542 30.9162 18.6369 31.0816C18.7205 31.2272 18.8461 31.3441 18.9972 31.4171C19.1689 31.5 19.3877 31.5 19.8252 31.5H21.3105C21.8106 31.5 22.0607 31.5 22.2458 31.4003C22.4084 31.3126 22.5373 31.1734 22.6122 31.0046C22.6974 30.8124 22.6783 30.5631 22.6399 30.0644L22.3337 26.0833"
        stroke="#09090B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.417 27.3333C31.0278 27.3333 32.3337 24.9082 32.3337 21.9167C32.3337 18.9251 31.0278 16.5 29.417 16.5M29.417 27.3333C27.8062 27.3333 26.5003 24.9082 26.5003 21.9167C26.5003 18.9251 27.8062 16.5 29.417 16.5M29.417 27.3333L18.5366 25.3551C17.7637 25.2146 17.3772 25.1443 17.0648 24.9908C16.4291 24.6785 15.9556 24.1113 15.7621 23.4299C15.667 23.095 15.667 22.7022 15.667 21.9167C15.667 21.1311 15.667 20.7383 15.7621 20.4034C15.9556 19.7221 16.4291 19.1548 17.0648 18.8425C17.3772 18.689 17.7637 18.6188 18.5366 18.4783L29.417 16.5M18.167 25.6667L18.4952 30.2617C18.5264 30.698 18.542 30.9162 18.6369 31.0816C18.7205 31.2272 18.8461 31.3441 18.9972 31.4171C19.1689 31.5 19.3877 31.5 19.8252 31.5H21.3105C21.8106 31.5 22.0607 31.5 22.2458 31.4003C22.4084 31.3126 22.5373 31.1734 22.6122 31.0046C22.6974 30.8124 22.6783 30.5631 22.6399 30.0644L22.3337 26.0833"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.417 27.3333C31.0278 27.3333 32.3337 24.9082 32.3337 21.9167C32.3337 18.9251 31.0278 16.5 29.417 16.5M29.417 27.3333C27.8062 27.3333 26.5003 24.9082 26.5003 21.9167C26.5003 18.9251 27.8062 16.5 29.417 16.5M29.417 27.3333L18.5366 25.3551C17.7637 25.2146 17.3772 25.1443 17.0648 24.9908C16.4291 24.6785 15.9556 24.1113 15.7621 23.4299C15.667 23.095 15.667 22.7022 15.667 21.9167C15.667 21.1311 15.667 20.7383 15.7621 20.4034C15.9556 19.7221 16.4291 19.1548 17.0648 18.8425C17.3772 18.689 17.7637 18.6188 18.5366 18.4783L29.417 16.5M18.167 25.6667L18.4952 30.2617C18.5264 30.698 18.542 30.9162 18.6369 31.0816C18.7205 31.2272 18.8461 31.3441 18.9972 31.4171C19.1689 31.5 19.3877 31.5 19.8252 31.5H21.3105C21.8106 31.5 22.0607 31.5 22.2458 31.4003C22.4084 31.3126 22.5373 31.1734 22.6122 31.0046C22.6974 30.8124 22.6783 30.5631 22.6399 30.0644L22.3337 26.0833"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ProgressIcon = (props: ProgressIconProps) => {
  const { progress } = props;

  const radius = 41;
  const circumference = radius * Math.PI * 2;
  const dash = (progress * circumference) / 100;
  const size = 96;
  return (
    <svg
      {...props}
      width={size}
      height={size}
      viewBox={`0 0 96 96`}
      fill="transparent"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle stroke="#D4D4D8" cx={48} cy={48} r={radius} strokeWidth="6" />
      <circle
        stroke="#3DD69E"
        cx={48}
        cy={48}
        r={radius}
        strokeWidth="6"
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
        strokeDasharray={`${dash}, ${circumference - dash}`}
        style={{ transition: "all 0.3s ease" }}
      />
    </svg>
  );
};

export const SurveyIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const { mode } = props;
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_111_19)">
        <circle cx="24" cy="24" r="24" fill={mode === "light" ? "#E4E4E7" : "#3F3F46"} />
        <path
          d="M33 24L21 24M33 18L21 18M33 30L21 30M17 24C17 24.5523 16.5523 25 16 25C15.4477 25 15 24.5523 15 24C15 23.4477 15.4477 23 16 23C16.5523 23 17 23.4477 17 24ZM17 18C17 18.5523 16.5523 19 16 19C15.4477 19 15 18.5523 15 18C15 17.4477 15.4477 17 16 17C16.5523 17 17 17.4477 17 18ZM17 30C17 30.5523 16.5523 31 16 31C15.4477 31 15 30.5523 15 30C15 29.4477 15.4477 29 16 29C16.5523 29 17 29.4477 17 30Z"
          stroke="#09090B"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33 24L21 24M33 18L21 18M33 30L21 30M17 24C17 24.5523 16.5523 25 16 25C15.4477 25 15 24.5523 15 24C15 23.4477 15.4477 23 16 23C16.5523 23 17 23.4477 17 24ZM17 18C17 18.5523 16.5523 19 16 19C15.4477 19 15 18.5523 15 18C15 17.4477 15.4477 17 16 17C16.5523 17 17 17.4477 17 18ZM17 30C17 30.5523 16.5523 31 16 31C15.4477 31 15 30.5523 15 30C15 29.4477 15.4477 29 16 29C16.5523 29 17 29.4477 17 30Z"
          stroke={mode === "light" ? "black" : "white"}
          strokeOpacity="0.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33 24L21 24M33 18L21 18M33 30L21 30M17 24C17 24.5523 16.5523 25 16 25C15.4477 25 15 24.5523 15 24C15 23.4477 15.4477 23 16 23C16.5523 23 17 23.4477 17 24ZM17 18C17 18.5523 16.5523 19 16 19C15.4477 19 15 18.5523 15 18C15 17.4477 15.4477 17 16 17C16.5523 17 17 17.4477 17 18ZM17 30C17 30.5523 16.5523 31 16 31C15.4477 31 15 30.5523 15 30C15 29.4477 15.4477 29 16 29C16.5523 29 17 29.4477 17 30Z"
          stroke={mode === "light" ? "black" : "white"}
          strokeOpacity={mode === "light" ? "0.2" : "1"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_111_19">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const QuizIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const { mode } = props;
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_113_16)">
        <circle cx="24" cy="24" r="24" fill={mode === "light" ? "#E4E4E7" : "#3F3F46"} />
        <path
          d="M23.5 17H23.9344C26.9816 17 28.5053 17 29.0836 17.5473C29.5836 18.0204 29.8051 18.7173 29.6702 19.3922C29.514 20.173 28.2701 21.0529 25.7823 22.8125L21.7177 25.6875C19.2299 27.4471 17.986 28.327 17.8298 29.1078C17.6949 29.7827 17.9164 30.4796 18.4164 30.9527C18.9947 31.5 20.5184 31.5 23.5656 31.5H24.5M20 17C20 18.6569 18.6569 20 17 20C15.3431 20 14 18.6569 14 17C14 15.3431 15.3431 14 17 14C18.6569 14 20 15.3431 20 17ZM34 31C34 32.6569 32.6569 34 31 34C29.3431 34 28 32.6569 28 31C28 29.3431 29.3431 28 31 28C32.6569 28 34 29.3431 34 31Z"
          stroke="#09090B"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.5 17H23.9344C26.9816 17 28.5053 17 29.0836 17.5473C29.5836 18.0204 29.8051 18.7173 29.6702 19.3922C29.514 20.173 28.2701 21.0529 25.7823 22.8125L21.7177 25.6875C19.2299 27.4471 17.986 28.327 17.8298 29.1078C17.6949 29.7827 17.9164 30.4796 18.4164 30.9527C18.9947 31.5 20.5184 31.5 23.5656 31.5H24.5M20 17C20 18.6569 18.6569 20 17 20C15.3431 20 14 18.6569 14 17C14 15.3431 15.3431 14 17 14C18.6569 14 20 15.3431 20 17ZM34 31C34 32.6569 32.6569 34 31 34C29.3431 34 28 32.6569 28 31C28 29.3431 29.3431 28 31 28C32.6569 28 34 29.3431 34 31Z"
          stroke={mode === "light" ? "black" : "white"}
          strokeOpacity={mode === "light" ? "0.2" : "1"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.5 17H23.9344C26.9816 17 28.5053 17 29.0836 17.5473C29.5836 18.0204 29.8051 18.7173 29.6702 19.3922C29.514 20.173 28.2701 21.0529 25.7823 22.8125L21.7177 25.6875C19.2299 27.4471 17.986 28.327 17.8298 29.1078C17.6949 29.7827 17.9164 30.4796 18.4164 30.9527C18.9947 31.5 20.5184 31.5 23.5656 31.5H24.5M20 17C20 18.6569 18.6569 20 17 20C15.3431 20 14 18.6569 14 17C14 15.3431 15.3431 14 17 14C18.6569 14 20 15.3431 20 17ZM34 31C34 32.6569 32.6569 34 31 34C29.3431 34 28 32.6569 28 31C28 29.3431 29.3431 28 31 28C32.6569 28 34 29.3431 34 31Z"
          stroke={mode === "light" ? "black" : "white"}
          strokeOpacity={mode === "light" ? "0.2" : "1"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_113_16">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
